import { Component, EventEmitter, ElementRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MaPlatePreparationService } from '../ma-plate-preparation/ma-plate-preparation.service';
import { MaStorageService } from '../ma-storage/ma-storage.service';
import { MasterDataService } from '../masterdata/masterdata.service';
import { MessagesService } from '../messages/messages.service';
import { Plate } from '../models/plate';
import { Step } from '../models/step';
import { ProcessStepStage } from '../models/process-step-stages';
import { ErrorHandler } from '../utils/error-handler';
import { PlateStatus, ProcessStep } from '../models/process-step';
import { Action } from '../models/action';
import { StepAction } from '../models/step-action';
import { Machine } from '../masterdata/models/machine';
import { saveAs as saveByFileSaver } from "file-saver";
import { MultiMergePlateQCUpdate, MultiPlateUpdate, PlateUpdateInfo, PrecellPlateInfo } from '../ma-plate-preparation/multiplate-update-dto';
import { ProcessFlow } from '../masterdata/models/processFlow';
import { WorkFlow } from '../masterdata/models/workFlow';
import { Dropdown } from 'primeng/dropdown';
import { PlateIdTypes } from '../models/plateid-types-enum';
import { RedoType } from '../models/redo-type-enum';
import { Sample } from '../models/sample';
import { AnnouncedService } from '../apg-announced/services/announced.service';
import { SampleRedoDTO } from '../models/sampleRedoDTO';
import rfdc from 'rfdc';
import { AnalysisType } from '../models/analysis-type';

@Component({
  selector: 'app-ma-plate-preparation-axiom',
  templateUrl: './ma-plate-preparation-axiom.component.html',
  styleUrls: ['./ma-plate-preparation-axiom.component.css']
})
export class MaPlatePreparationAxiomComponent implements OnInit {
  errorHandler: ErrorHandler = new ErrorHandler;
  blocked = false;
  selectedLabId: string;
  workFlowData: WorkFlow[] = [];
  puid: string;

  @Input() multiPlate: boolean;
  @Input() selectedPlate: Plate;
  @Input() selectedPlateStepsMap: Map<string, Step>;
  @Input() selectedPlateProcessFlow: ProcessFlow
  @Output() updatePlateDataEmitter = new EventEmitter<any>();
  @Output() reloadPlateTableEmitter = new EventEmitter();
  @Output() plateViewResetEmitter = new EventEmitter();

  isLynxFileNotSelected: boolean = true;
  uploadedLynxFile: File;
  uploadedLynxFileContent: any
  @ViewChild('manualLynxFileUpload') lynxFileUploadElement: ElementRef;
  isPrecellFileNotSelected: boolean = true;
  uploadedPrecellFile: File;
  uploadedPrecellFileContent : any;
  @ViewChild('manualPrecellFileUpload') precellFileUploadElement: ElementRef;

  multiUpdateProcessStepsMap: Map<string, Step> = new Map();
  mapOfProcessStepsFlowAxiom384: Map<string, string[]> = new Map();
  mapOfProcessStepAndActionAxiom384: Map<string, string[]> = new Map();
  mapOfPopUpProcessStepAndActionAxiom384: Map<string, string[]> = new Map();
  mapOfActionRuntimeAxiom384: Map<string, number> = new Map();
  sampleTypeAliquotVolumeMap = []
  aliquotationLiquidHandler: string = '';
  aliquotPlateID: string = '';
  mapOfStatusSaves = new Map();
  mapOfStatusAndPopUpValues = new Map();
  selectedStorage: Storage = null;
  storageList: Array<any> = [];
  machineProcessStepStatusMap = new Map();
  processFlows: ProcessFlow[] = []
  machinesList: Machine[];
  machinesBarcodeMap: Map<string, Machine> = new Map();

  multiStage: number;
  multiActionName: string;
  multiActionPos: number;
  multiStepName: string;
  multiUpdateStatus: string;
  multiCompleteProcessStep: boolean;
  multiCompleteProcessStepStatus: string;
  multiUpdateStatusLabel: string;
  multiUpdateButtonLabel: string;
  mapOfStatusAndLabel = new Map();
  multiUpdateButtonStyleClass: string;
  multiLiquidHandler: string = "";
  multiChemicalLot: string = "";
  enteredPlateId: string;
  enteredAliquotPlateId: string;
  fetchedPlate: Plate;
  multiPlateStepsMap: Map<string, Step>;
  multiPlateStepsMapList: Array<Map<string, Step>>;
  multiMachineUpdateInfoDict = new Map();
  multiUpdatePlateList: string[] = [];
  multiUpdateRestorePlateList: string[] = [];
  multiUpdatePlateListSave: string[] = [];
  multiUpdatePlateInfoList: PlateUpdateInfo[]=[];
  multiUpdateSelectedWorkFlow: string = "";
  precellPlateList : string[]=[];
  precellPlateData : PrecellPlateInfo[]=[];
  precellPopupWorkfile = true;
  showPrecellPlatesPopup = false;
  precellChemical1: string = "";
  precellChemical2: string = "";
  precellChemical3: string = "";
  multiUpdateInputLabel: string;
  selectedPopUpString="";

  multiShakeRequired: boolean = false;
  multiShakeCheckboxValue: boolean = false;
  multiSpinRequired: boolean = false;
  multiSpinCheckboxValue = false
  multiShakeHeader: string = "";
  multiSpinHeader: string = "QuickSpin the Plates";
  multiPreSpinRequired: boolean = false;
  multiPreSpinCheckboxValue = false
  multiPreSpinHeader: string = "QuickSpin the Plates";
  multiSealRequired: boolean = false;
  multiSealLiquidHandler: string = "";
  multiSealHeader: string = "Heat seal the plates";
  multiNextStep: boolean = false;
  multiAirDryRequired: boolean = false;
  multiAirDryHeader: string = "Air dry the plates for 30 mins";
  multiLiquidHandlerRequired: boolean = true
  multiPlateIdRequired: Array<boolean> = [false,false];
  multiAliquotPlateIdRequired: Array<boolean> = [false,false];
  addFirstActionStatusList: Array<string> = [PlateStatus.PRECIPITATION_STARTED,PlateStatus.DENATURATION_STARTED];

  popUpWithMachineAndChemicalsHeader1: string = "";
  popUpWithMachineAndChemicalsHeader2: string = "";
  popUpWithMachineAndChemicalsChemical: string = "";
  showConfirmPlatesPopupHeader1: string = "";
  showConfirmPlatesPopupHeader2: string = "";
  showConfirmPlatesPopupHeader3: string = "";
  popUpWithDifferentMachineHeader: string = "";
  popUpWithDifferentMachineEquipmentPlaceholder: string = "";
  popUpWithQCCheckHeader1: string = "";
  popUpWithQCCheckHeader2: string = "";

  lastUpdatedPlates1: any[] = [];
  lastUpdatedPlates2: any[] = [];
  lastUpdatedPlates3: any[] = [];
  chemicalsPlateids: any[] = [];

  popUpWithMachineAndChemicals: boolean = false;
  popUpWithMachineAndChemicalsClosable: boolean = true;
  popUpWithDifferentMachine: boolean = false;
  showConfirmPlatesPopup: boolean = false;
  popUpWithQCCheck: boolean = false;
  selectedProcessStep: string;
  processStepChemicals: any;
  mapOfProcessStepsStatus = new Map();
  multiDenatChemicalLotList: String[]=[];
  multiAmpChemicalLotList: String[]=[];
  multiNeutChemicalLotList: String[]=[];
  qcFailPlateSampleMap: Map<string, Sample[]> = new Map<string, Sample[]>();

  noChemicalEdit: boolean;
  lastUpdatedStatus: string;
  multiChemicalEdit: boolean;
  showDialogue: boolean;
  qcPass: boolean = false;
  multiPopupWithMachineAndChemicalsTableHeader: string = "";
  redoList = [];
  hairRedoList = [
    {label:"Lysis Redo",value: {"redoLabel":"Lysis Redo","redo":RedoType.LYSIS_REDO,"status":PlateStatus.PLATE_REDO,"stepName":"","sampleType":"Hair"}},
    {label:"Extraction Redo",value: {"redoLabel":"Extraction Redo","redo":RedoType.EXTRACTION_REDO,"status":PlateStatus.LYSIS_STARTED,"stepName":ProcessStep.EXTRACTION,"sampleType":"Hair"}},
    {label:"Aliquotation Redo",value: {"redoLabel":"Aliquotation Redo","redo":RedoType.ALIQUOTATION_REDO,"status":PlateStatus.EXTRACTION_COMPLETED,"stepName":ProcessStep.ALIQUOTATION,"sampleType":"Hair"}}
  ]
  eartagRedoList = [
    {label:"Extraction Redo",value: {"redoLabel":"Extraction Redo","redo":RedoType.EXTRACTION_REDO,"status":PlateStatus.LYSIS_COMPLETED,"stepName":ProcessStep.EXTRACTION,"sampleType":"Eartag"}},
    {label:"Aliquotation Redo",value: {"redoLabel":"Aliquotation Redo","redo":RedoType.ALIQUOTATION_REDO,"status":PlateStatus.EXTRACTION_COMPLETED,"stepName":ProcessStep.ALIQUOTATION,"sampleType":"Eartag"}}
  ]
  tlrRedoList = [
    {label:"Aliquotation Redo",value: {"redoLabel":"Aliquotation Redo","redo":RedoType.ALIQUOTATION_REDO,"status":PlateStatus.EXTRACTION_COMPLETED,"stepName":ProcessStep.ALIQUOTATION,"sampleType":"TLR"}}
  ]
  selectedRedoType: any;
  qcPassSelectedRedoType = {"redoLabel":"No Redo","redo":RedoType.NO_REDO,"status":PlateStatus.PRECIPITATION_STARTED,"stepName":"","sampleType":""};
  disableRedoTypeSelection: boolean = true;
  @ViewChild('popUpRedoSelector') popUpRedoSelector: Dropdown;
  ismultiLiquidHandler = false
  ismultiSealLiquidHandler = false
  multiChemicalLots : string[] = []

  popUpWithQCCheckForMergePlate:boolean = false;
  mergePlateRedoSelection: Array<any> = [];
  mergePlateRedoList: Array<Array<any>> = [];
  multiUpdateMergeRedoPlates: Map<string, Array<PlateUpdateInfo>> = new Map();
  clone = rfdc();
  underFilledPlate: Set<string> = new Set();

  constructor(
    private masterDataService: MasterDataService, private _messagesService: MessagesService,
    private announcementService:AnnouncedService,
    private _maStorageService: MaStorageService, private platePreparationService: MaPlatePreparationService) { }

  ngOnInit() {
    this.puid = localStorage.getItem("PUID");
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.getAllProcessFlows();
    this.multiPlateStepsMap = new Map();
    this.multiPlateStepsMapList = new Array();
    this.fetchAllActiveMachines();
    this.workFlowData = JSON.parse(localStorage.getItem('workFlowData'));

    this.mapOfStatusSaves.set(PlateStatus.ALIQUOTATION_STARTED, "startAliquotation")
    this.mapOfStatusSaves.set(PlateStatus.ALIQUOTATION_COMPLETED, "completeAliquotation")
    this.mapOfStatusSaves.set(PlateStatus.WGA_STARTED, "startWGA");
    this.mapOfStatusSaves.set(PlateStatus.WGA_COMPLETED, "completeWGA");
    this.mapOfStatusSaves.set(PlateStatus.FRAGMENTATION_STARTED, "startFragmentation");
    this.mapOfStatusSaves.set(PlateStatus.FRAGMENTATION_COMPLETED, "completeFragmentation");
    this.mapOfStatusSaves.set(PlateStatus.PRECIPITATION_STARTED, "startPrecipitation");
    this.mapOfStatusSaves.set(PlateStatus.PRECIPITATION_COMPLETED, "completePrecipitation");
    this.mapOfStatusSaves.set(PlateStatus.RESUSPENDING_STARTED, "startResuspending");
    this.mapOfStatusSaves.set(PlateStatus.RESUSPENDING_COMPLETED, "completeResuspending");
    this.mapOfStatusSaves.set(PlateStatus.DENATURATION_STARTED, "startDenaturation");
    this.mapOfStatusSaves.set(PlateStatus.DENATURATION_COMPLETED, "completeDenaturation");
    this.mapOfStatusSaves.set(Action.INCUBATE_WGA_RT, "actionIncubateWGART");
    this.mapOfStatusSaves.set(Action.STOP_INCUBATION_WGA_RT, "actionStopIncubationWGART");
    this.mapOfStatusSaves.set(Action.INCUBATE_WGA_37C, "actionIncubateWGA37c");
    this.mapOfStatusSaves.set(Action.STOP_INCUBATION_WGA_37C, "actionStopIncubationWGA37c");
    this.mapOfStatusSaves.set(Action.CENTRIFUGE, "actionCentrifuge");
    this.mapOfStatusSaves.set(Action.STOP_CENTRIFUGATION, "actionStopCentrifugation");
    this.mapOfStatusSaves.set(Action.MAX_DRYING_TIME, "actionMaxDryingTime");
    this.mapOfStatusSaves.set(Action.STOP_DRYING, "actionStopDrying");
    this.mapOfStatusSaves.set(Action.INCUBATE_95C, "actionIncubate95c");
    this.mapOfStatusSaves.set(Action.STOP_INCUBATE_95C,"actionStopIncubate95c")
    this.mapOfStatusSaves.set(Action.INCUBATE_48C, "actionIncubate48c");
    this.mapOfStatusSaves.set(Action.STOP_INCUBATE_48C,"actionStopIncubate48c")
    this.mapOfStatusSaves.set(Action.INCUBATE_37C, "actionIncubate37c");
    this.mapOfStatusSaves.set(Action.STOP_INCUBATION_37C, "actionStopIncubation37c");
    this.mapOfStatusSaves.set(Action.INCUBATE_NEG_20C, "actionIncubateNeg20c");
    this.mapOfStatusSaves.set(Action.STOP_INCUBATION_NEG_20C, "actionStopIncubationNeg20c");
    this.mapOfStatusSaves.set(Action.INCUBATION_58C, "actionIncubation58c");
    this.mapOfStatusSaves.set(Action.SHAKING,"actionShaking")
    this.mapOfStatusSaves.set(Action.STOP_SHAKING,"actionStopShaking")

    this.mapOfStatusAndPopUpValues.set(PlateStatus.ALIQUOTATION_STARTED,
      {
        "popUpName":"showConfirmPlatesPopup", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":["Scan Plates:"],
        "preSpin": false, "spin": false, "shake": false, "seal":false, "buttonLabel": "Start Aliquotation",
        "nextStep": false, "nextStepParams": ["", 0, "", "", 0]
      }
    );
    this.mapOfStatusAndPopUpValues.set(PlateStatus.ALIQUOTATION_COMPLETED,
      {
        "popUpName":"showConfirmPlatesPopup", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID, PlateIdTypes.ALIQUOT],
        "headers":["Scan Plates:"],
        "preSpin": false, "spin": false, "shake": false, "seal":false, "buttonLabel": "Complete Aliquot.",
        "nextStep": false, "nextStepParams": ["", 0, "", "", 0]
      }
    );
    this.mapOfStatusAndPopUpValues.set(PlateStatus.WGA_STARTED,
      {
        "popUpName":"popUpWithMachineAndChemicals", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":["Aliquot Plates:", "Add 10µL Denaturation Solution", "Denat. Solution", "Shake the plates for 30 sec at 1100 rpm"],
        "preSpin": true, "spin": true, "shake": true, "seal":false, "buttonLabel": "Next Step",
        "nextStep": true, "nextStepParams": [Action.INCUBATE_WGA_RT, 2, ProcessStep.AMPLIFY_WGA, Action.INCUBATE_WGA_RT, 0]
      }
    );
    this.mapOfStatusAndPopUpValues.set(Action.INCUBATE_WGA_RT,
      {
        "popUpName":"showConfirmPlatesPopup", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":["Incubate at RT for 10 minutes"],
        "preSpin": false, "spin": false, "shake": false, "seal":false, "buttonLabel": "Incubate WGA RT",
        "nextStep": false, "nextStepParams": ["", 0, "", "", 0]
      }
    );
    this.mapOfStatusAndPopUpValues.set(Action.STOP_INCUBATION_WGA_RT,
      {
        "popUpName":"showConfirmPlatesPopup", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":["Stop Incubation"],
        "preSpin": false, "spin": false, "shake": false, "seal":false, "buttonLabel": "Next Step",
        "nextStep": true, "nextStepParams": [Action.NEUTRALIZATION, 2, ProcessStep.AMPLIFY_WGA, Action.NEUTRALIZATION, 2]
      }
    );
    this.mapOfStatusAndPopUpValues.set(Action.NEUTRALIZATION,
      {
        "popUpName":"popUpWithMachineAndChemicals", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":["Aliquot Plates:", "Add 65µL Neutralization Solution", "Neut. Solution", "Shake the plates for 30 sec at 1100 rpm"],
        "preSpin": false, "spin": true, "shake": true, "seal":false, "buttonLabel": "Next Step",
        "nextStep": true, "nextStepParams": [Action.AMPLIFICATION, 2, ProcessStep.AMPLIFY_WGA, Action.AMPLIFICATION, 3]
      }
    );
    this.mapOfStatusAndPopUpValues.set(Action.AMPLIFICATION,
      {
        "popUpName":"popUpWithMachineAndChemicals", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":["Aliquot Plates:", "Add 115µL Amplification Master Mix", "Ampl. MasterMix", "Shake the plates for 30 sec at 1100 rpm"],
        "preSpin": false, "spin": true, "shake": true, "seal":false, "buttonLabel": "Next Step",
        "nextStep": true, "nextStepParams": [Action.INCUBATE_WGA_37C, 2, ProcessStep.AMPLIFY_WGA, Action.INCUBATE_WGA_37C, 4]
      }
    );
    this.mapOfStatusAndPopUpValues.set(Action.INCUBATE_WGA_37C,
      {
        "popUpName":"popUpWithDifferentMachine", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":["Incubate at 37°C for 4 - 24h", "Scan Oven-ID"],
        "preSpin": false, "spin": false, "shake": false, "seal":false, "buttonLabel": "Incubate WGA 37°C",
        "nextStep": false, "nextStepParams": ["", 0, "", "", 0]
      }
    );
    this.mapOfStatusAndPopUpValues.set(Action.STOP_INCUBATION_WGA_37C,
      {
        "popUpName":"showConfirmPlatesPopup", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":["Scan the incubated plates:", "Continue with Fragmentation?\nNo: freeze with amplification Plate\nYes: Continue with Start Fragmen."],
        "preSpin": false, "spin": false, "shake": false, "seal":false, "buttonLabel": "Complete WGA",
        "nextStep": false, "nextStepParams": ["", 0, "", "", 0], "processStepComplete":true, "processStepStatus":PlateStatus.WGA_COMPLETED
      }
    );
    this.mapOfStatusAndPopUpValues.set(PlateStatus.FRAGMENTATION_STARTED,
      {
        "popUpName":"popUpWithMachineAndChemicals", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":["Scan Plates:", "Add 30µL Fragmentation Master Mix", "Frag. Mix", "Shake the plates for 30 sec at 1100 rpm","If a plate was frozen after amplification, it\nneeds to be thawed and then in the oven\nfor 1h at 37°C"],
        "preSpin": true, "spin": true, "shake": true, "seal":false, "buttonLabel": "Next Step",
        "nextStep": true, "nextStepParams": [Action.INCUBATE_37C, 2, ProcessStep.FRAGMENT_DNA, Action.INCUBATE_37C, 0]
      }
    );
    this.mapOfStatusAndPopUpValues.set(Action.INCUBATE_37C,
      {
        "popUpName":"popUpWithDifferentMachine", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":["Incubate at 37°C for 30 min", "Scan Oven-ID"],
        "preSpin": false, "spin": false, "shake": false, "seal":false, "buttonLabel": "Incubate 37°C",
        "nextStep": false, "nextStepParams": ["", 0, "", "", 0]
      }
    );
    this.mapOfStatusAndPopUpValues.set(Action.STOP_INCUBATION_37C,
      {
        "popUpName":"showConfirmPlatesPopup", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":[""],
        "preSpin": false, "spin": false, "shake": false, "seal":false, "buttonLabel": "Next Step",
        "nextStep": true, "nextStepParams": [Action.FRAGMENTATION_1, 2, ProcessStep.FRAGMENT_DNA, Action.FRAGMENTATION_1, 2]
      }
    );
    this.mapOfStatusAndPopUpValues.set(Action.FRAGMENTATION_1,
      {
        "popUpName":"popUpWithMachineAndChemicals", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":["Scan Plates:", "Add 10µL Fragmentation Stop Solution", "Stop Solution", "Shake the plates for 30 sec at 1100 rpm"],
        "preSpin": true, "spin": true, "shake": true, "seal":false, "buttonLabel": "Next Step",
        "nextStep": true, "nextStepParams": [Action.FRAGMENTATION_2, 2, ProcessStep.FRAGMENT_DNA, Action.FRAGMENTATION_2, 3]
      }
    );
    this.mapOfStatusAndPopUpValues.set(Action.FRAGMENTATION_2,
      {
        "popUpName":"popUpWithMachineAndChemicals", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":["Aliquot Plates:", "Add 440µL Precip Master Mix", "Precip Mix", "Shake the plates for 60 sec at 2450 rpm"],
        "preSpin": false, "spin": false, "shake": true, "seal":true, "buttonLabel": "Next Step",
        "nextStep": true, "nextStepParams": [Action.INCUBATE_NEG_20C, 2, ProcessStep.FRAGMENT_DNA, Action.INCUBATE_NEG_20C, 4]
      }
    );
    this.mapOfStatusAndPopUpValues.set(Action.INCUBATE_NEG_20C,
      {
        "popUpName":"popUpWithDifferentMachine", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":["Incubate at -20°C for a minimum of 3 hours", "Scan Freezer ID"],
        "preSpin": false, "spin": false, "shake": false, "seal":false, "buttonLabel": "Incubate -20°C",
        "nextStep": false, "nextStepParams": ["", 0, "", "", 0]
      }
    );
    this.mapOfStatusAndPopUpValues.set(Action.STOP_INCUBATION_NEG_20C,
      {
        "popUpName":"showConfirmPlatesPopup", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":["Scan the incubated plates:"],
        "preSpin": false, "spin": false, "shake": false, "seal":false, "buttonLabel": "Complete Fragmen.",
        "nextStep": false, "nextStepParams": ["", 0, "", "", 0], "processStepComplete":true, "processStepStatus":PlateStatus.FRAGMENTATION_COMPLETED
      }
    );
    this.mapOfStatusAndPopUpValues.set(PlateStatus.PRECIPITATION_STARTED,
      {
        "popUpName":"popUpWithDifferentMachine", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":["Centrifuge Plate for 40 mins at 3200xg at 4°C", "Scan Centrifuge"],
        "preSpin": false, "spin": false, "shake": false, "seal":false, "buttonLabel": "Start Centrifuge",
        "nextStep": false, "nextStepParams": ["", 0, "", "", 0]
      }
    );
    this.mapOfStatusAndPopUpValues.set(Action.STOP_CENTRIFUGATION,
      {
        "popUpName":"showConfirmPlatesPopup", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":["Scan Plates:"],
        "preSpin": false, "spin": false, "shake": false, "seal":false, "buttonLabel": "Stop Centrifuge",
        "nextStep": false, "nextStepParams": ["", 0,"" ,"" ,0]
      }
    );
    this.mapOfStatusAndPopUpValues.set(Action.QC_CHECK,
      {
        "popUpName":"popUpWithQCCheck", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":["Scan Plates:", "Redo"],
        "preSpin": false, "spin": false, "shake": false, "seal":false, "buttonLabel": "Continue",
        "nextStep": true, "nextStepParams": [Action.MAX_DRYING_TIME, 2, ProcessStep.PRECIPITATE_DNA, Action.MAX_DRYING_TIME, 3]
      }
    );
    this.mapOfStatusAndPopUpValues.set(Action.MAX_DRYING_TIME,
      {
        "popUpName":"popUpWithMachineAndChemicals", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":["Scan Plates:", "", "", "Invert the plates and tap to remove supernatant"],
        "preSpin": false, "spin": false, "shake": true, "airdry": true, "seal":false, "buttonLabel": "Start Drying",
        "nextStep": false, "nextStepParams": ["", 0, "", "", 0]
      }
    );
    this.mapOfStatusAndPopUpValues.set(Action.STOP_DRYING,
      {
        "popUpName":"showConfirmPlatesPopup", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":["Scan Plates:","Continue with Resuspending?\nNo: freeze the plates\nYes: Continue"],
        "preSpin": false, "spin": false, "shake": false, "seal":false, "buttonLabel": "Complete Precipit.",
        "nextStep": false, "nextStepParams": ["", 0, "", "", 0], "processStepComplete":true, "processStepStatus":PlateStatus.PRECIPITATION_COMPLETED
      }
    );
    this.mapOfStatusAndPopUpValues.set(PlateStatus.RESUSPENDING_STARTED,
      {
        "popUpName":"popUpWithMachineAndChemicals", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":["Aliquot Plates:", "Add 50µL Resus & Hyb Mix", "Resus & Hyb Mix"],
        "preSpin": false, "spin": false, "shake": false, "seal":true, "buttonLabel": "Next Step",
        "nextStep": true, "nextStepParams": [Action.SHAKING,2,ProcessStep.RESUSPEND_DNA,Action.SHAKING,0]
      }
    );
    this.mapOfStatusAndPopUpValues.set(
      Action.SHAKING,
      {
        "popUpName":"popUpWithDifferentMachine", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":["Shake the plates for 15 mins at 1100 rpm.", "Scan Shaker"],
        "preSpin": false, "spin": false, "shake": false, "seal":false, "buttonLabel": "Start Shaking",
        "nextStep": false, "nextStepParams": ["", 0, "", "", 0]
      }
    )
    this.mapOfStatusAndPopUpValues.set(
      Action.STOP_SHAKING,
      {
        "popUpName":"showConfirmPlatesPopup", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":["Scan Plates","Continue with Denaturation?\nNo: freeze the plates\nYes: Continue","Is pellet resuspended?\nNo: Shake Again\nYes: QuickSpin the plates"],
        "preSpin": false, "spin": true, "shake": false, "seal":false, "buttonLabel": "Complete Resus.",
        "nextStep": false, "nextStepParams": ["", 0, "", "", 0],"processStepComplete":true, "processStepStatus":PlateStatus.RESUSPENDING_COMPLETED
      }
    )
    this.mapOfStatusAndPopUpValues.set(
      PlateStatus.DENATURATION_STARTED,
      {
        "popUpName":"popUpWithDifferentMachine", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":["Incubate at 95°C for 10 min.", "Scan Incubator-ID"],
        "preSpin": false, "spin": false, "shake": false, "seal":false, "buttonLabel": "Incubate 95°C",
        "nextStep": false, "nextStepParams":  ["", 0, "", "", 0]
      }
    );
    this.mapOfStatusAndPopUpValues.set(
      Action.STOP_INCUBATE_95C,
      {
        "popUpName":"showConfirmPlatesPopup", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":[""],
        "preSpin": false, "spin": false, "shake": false, "seal":false, "buttonLabel": "Stop Incubation",
        "nextStep": false, "nextStepParams":  ["", 0, "", "", 0]
      }
    )
    this.mapOfStatusAndPopUpValues.set(
      Action.INCUBATE_48C,
      {
        "popUpName":"popUpWithDifferentMachine", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":["Incubate at 48°C for 3 min.", "Scan Oven-ID"],
        "preSpin": false, "spin": false, "shake": false, "seal":false, "buttonLabel": "Start Incubation",
        "nextStep": true, "nextStepParams":  ["", 0, "", "", 0]
      }
    );
    this.mapOfStatusAndPopUpValues.set(
      Action.STOP_INCUBATE_48C,
      {
        "popUpName":"showConfirmPlatesPopup", "requiredFields":[PlateIdTypes.LAST_UPDATED_PLATEID],
        "headers":["Scan Plates"],
        "preSpin": false, "spin": false, "shake": false, "seal":false, "buttonLabel": "Complete Denatu.",
        "nextStep": false, "nextStepParams": ["", 0, "", "", 0],"processStepComplete":true, "processStepStatus":PlateStatus.DENATURATION_COMPLETED
      }
    )


    this.mapOfStatusAndLabel.set(PlateStatus.ALIQUOTATION_STARTED, "Start Aliquotation")
    this.mapOfStatusAndLabel.set(PlateStatus.ALIQUOTATION_COMPLETED, "Complete Aliquot.")
    this.mapOfStatusAndLabel.set(PlateStatus.WGA_STARTED, "Start WGA")
    this.mapOfStatusAndLabel.set(Action.INCUBATE_WGA_RT, "Incubate WGA RT")
    this.mapOfStatusAndLabel.set(Action.STOP_INCUBATION_WGA_RT, "Stop Incubation")
    this.mapOfStatusAndLabel.set(Action.NEUTRALIZATION, "Neutralization")
    this.mapOfStatusAndLabel.set(Action.AMPLIFICATION, "Amplification")
    this.mapOfStatusAndLabel.set(Action.INCUBATE_WGA_37C, "Incubate WGA 37°C")
    this.mapOfStatusAndLabel.set(Action.STOP_INCUBATION_WGA_37C, "Complete WGA")
    this.mapOfStatusAndLabel.set(PlateStatus.FRAGMENTATION_STARTED, "Start Fragmen.")
    this.mapOfStatusAndLabel.set(Action.INCUBATE_37C, "Incubate 37°C")
    this.mapOfStatusAndLabel.set(Action.STOP_INCUBATION_37C, "Stop Incubation")
    this.mapOfStatusAndLabel.set(Action.FRAGMENTATION_1, "Fragmentation 1")
    this.mapOfStatusAndLabel.set(Action.FRAGMENTATION_2, "Fragmentation 2")
    this.mapOfStatusAndLabel.set(Action.INCUBATE_NEG_20C, "Incubate -20°C")
    this.mapOfStatusAndLabel.set(Action.STOP_INCUBATION_NEG_20C, "Complete Fragmentation")
    this.mapOfStatusAndLabel.set(PlateStatus.PRECIPITATION_STARTED, "Start Precipitation")
    this.mapOfStatusAndLabel.set(Action.STOP_CENTRIFUGATION, "Complete Centrifugation")
    this.mapOfStatusAndLabel.set(Action.QC_CHECK, "QC Check")
    this.mapOfStatusAndLabel.set(Action.MAX_DRYING_TIME, "Air Drying")
    this.mapOfStatusAndLabel.set(Action.STOP_DRYING, "Complete Precipitation")
    this.mapOfStatusAndLabel.set(PlateStatus.RESUSPENDING_STARTED, "Start Resus.")
    this.mapOfStatusAndLabel.set(Action.INCUBATION_58C, "Incubation 58°C")
    this.mapOfStatusAndLabel.set(PlateStatus.RESUSPENDING_COMPLETED, "Complete Resus.")
    this.mapOfStatusAndLabel.set(PlateStatus.DENATURATION_STARTED, "Start Denaturation")
    this.mapOfStatusAndLabel.set(Action.INCUBATE_95C, "Incubate 95°C")
    this.mapOfStatusAndLabel.set(Action.STOP_INCUBATE_95C,"Stop Incubate 95°C")
    this.mapOfStatusAndLabel.set(Action.STOP_INCUBATE_48C,"Stop Incubate 48°C")
    this.mapOfStatusAndLabel.set(Action.INCUBATE_RT, "Incubate RT")
    this.mapOfStatusAndLabel.set(Action.INCUBATE_48C, "Incubate 48°C")
    this.mapOfStatusAndLabel.set(Action.SHAKING,"Shake Plates")
    this.mapOfStatusAndLabel.set(Action.STOP_SHAKING,"Stop Shaking")
    this.mapOfStatusAndLabel.set(PlateStatus.DENATURATION_COMPLETED, "Complete Denatu.")

    this.mapOfProcessStepsFlowAxiom384.set(ProcessStep.ALIQUOTATION, [ProcessStep.RECEIVE_PLATE]);
    this.mapOfProcessStepsFlowAxiom384.set(ProcessStep.AMPLIFY_WGA, [ProcessStep.ALIQUOTATION]);
    this.mapOfProcessStepsFlowAxiom384.set(ProcessStep.FRAGMENT_DNA, [ProcessStep.AMPLIFY_WGA])
    this.mapOfProcessStepsFlowAxiom384.set(ProcessStep.PRECIPITATE_DNA, [ProcessStep.FRAGMENT_DNA])
    this.mapOfProcessStepsFlowAxiom384.set(ProcessStep.RESUSPEND_DNA, [ProcessStep.PRECIPITATE_DNA])
    this.mapOfProcessStepsFlowAxiom384.set(ProcessStep.DENATURATE_DNA, [ProcessStep.RESUSPEND_DNA])

    this.mapOfProcessStepAndActionAxiom384.set(ProcessStep.AMPLIFY_WGA, [Action.INCUBATE_WGA_RT, Action.STOP_INCUBATION_WGA_RT, Action.INCUBATE_WGA_37C, Action.STOP_INCUBATION_WGA_37C]);
    this.mapOfProcessStepAndActionAxiom384.set(ProcessStep.PRECIPITATE_DNA, [Action.CENTRIFUGE, Action.STOP_CENTRIFUGATION, Action.MAX_DRYING_TIME, Action.STOP_DRYING]);
    this.mapOfProcessStepAndActionAxiom384.set(ProcessStep.DENATURATE_DNA, [Action.INCUBATE_95C,Action.STOP_INCUBATE_95C, Action.INCUBATE_48C,Action.STOP_INCUBATE_48C]);
    this.mapOfProcessStepAndActionAxiom384.set(ProcessStep.FRAGMENT_DNA, [Action.INCUBATE_37C, Action.STOP_INCUBATION_37C, Action.INCUBATE_NEG_20C, Action.STOP_INCUBATION_NEG_20C]);
    this.mapOfProcessStepAndActionAxiom384.set(ProcessStep.RESUSPEND_DNA,[Action.SHAKING,Action.STOP_SHAKING]);

    this.mapOfPopUpProcessStepAndActionAxiom384.set(ProcessStep.AMPLIFY_WGA, [Action.INCUBATE_WGA_RT, Action.STOP_INCUBATION_WGA_RT, Action.NEUTRALIZATION, Action.AMPLIFICATION, Action.INCUBATE_WGA_37C, Action.STOP_INCUBATION_WGA_37C]);
    this.mapOfPopUpProcessStepAndActionAxiom384.set(ProcessStep.PRECIPITATE_DNA, [Action.CENTRIFUGE, Action.STOP_CENTRIFUGATION, Action.QC_CHECK, Action.MAX_DRYING_TIME, Action.STOP_DRYING]);
    this.mapOfPopUpProcessStepAndActionAxiom384.set(ProcessStep.DENATURATE_DNA, [Action.INCUBATE_95C,Action.STOP_INCUBATE_95C, Action.INCUBATE_48C,Action.STOP_INCUBATE_48C]);
    this.mapOfPopUpProcessStepAndActionAxiom384.set(ProcessStep.RESUSPEND_DNA,[Action.SHAKING,Action.STOP_SHAKING]);
    this.mapOfPopUpProcessStepAndActionAxiom384.set(ProcessStep.FRAGMENT_DNA, [Action.INCUBATE_37C, Action.STOP_INCUBATION_37C, Action.FRAGMENTATION_1, Action.FRAGMENTATION_2, Action.INCUBATE_NEG_20C, Action.STOP_INCUBATION_NEG_20C]);

    this.mapOfActionRuntimeAxiom384.set(Action.INCUBATE_WGA_RT, 10)
    this.mapOfActionRuntimeAxiom384.set(Action.STOP_INCUBATION_WGA_RT, 0)
    this.mapOfActionRuntimeAxiom384.set(Action.NEUTRALIZATION, 0)
    this.mapOfActionRuntimeAxiom384.set(Action.AMPLIFICATION, 0)
    this.mapOfActionRuntimeAxiom384.set(Action.INCUBATE_WGA_37C, 240)
    this.mapOfActionRuntimeAxiom384.set(Action.STOP_INCUBATION_WGA_37C, 0)
    this.mapOfActionRuntimeAxiom384.set(Action.INCUBATE_37C, 30)
    this.mapOfActionRuntimeAxiom384.set(Action.STOP_INCUBATION_37C, 0)
    this.mapOfActionRuntimeAxiom384.set(Action.FRAGMENTATION_1, 0)
    this.mapOfActionRuntimeAxiom384.set(Action.FRAGMENTATION_2, 0)
    this.mapOfActionRuntimeAxiom384.set(Action.INCUBATE_NEG_20C, 180)
    this.mapOfActionRuntimeAxiom384.set(Action.STOP_INCUBATION_NEG_20C, 0)
    this.mapOfActionRuntimeAxiom384.set(Action.CENTRIFUGE, 40)
    this.mapOfActionRuntimeAxiom384.set(Action.STOP_CENTRIFUGATION, 0)
    this.mapOfActionRuntimeAxiom384.set(Action.QC_CHECK, 0)
    this.mapOfActionRuntimeAxiom384.set(Action.MAX_DRYING_TIME, 30)
    this.mapOfActionRuntimeAxiom384.set(Action.STOP_DRYING, 0)
    this.mapOfActionRuntimeAxiom384.set(Action.INCUBATE_95C, 10)
    this.mapOfActionRuntimeAxiom384.set(Action.INCUBATE_48C, 3);
    this.mapOfActionRuntimeAxiom384.set(Action.STOP_INCUBATE_48C,3)
    this.mapOfActionRuntimeAxiom384.set(Action.STOP_INCUBATE_95C,15)
    this.mapOfActionRuntimeAxiom384.set(Action.SHAKING,15)
    this.mapOfActionRuntimeAxiom384.set(Action.STOP_SHAKING,0)

    this.machineProcessStepStatusMap.set(PlateStatus.ALIQUOTATION_STARTED, 'ALIQOUTATION')
    this.machineProcessStepStatusMap.set(PlateStatus.WGA_STARTED, 'AMPLIFY_DNA')
    this.machineProcessStepStatusMap.set(PlateStatus.RECOMBINING_STARTED, ProcessStep.RECOMBINE_DNA)
    this.machineProcessStepStatusMap.set(PlateStatus.PRECIPITATION_STARTED, ProcessStep.PRECIPITATE_DNA)
    this.machineProcessStepStatusMap.set(PlateStatus.RESUSPENDING_STARTED, ProcessStep.RESUSPEND_DNA)

    this.mapOfProcessStepsStatus.set(PlateStatus.ALIQUOTATION_STARTED, [ProcessStep.ALIQUOTATION])
    this.mapOfProcessStepsStatus.set(PlateStatus.ALIQUOTATION_COMPLETED, [])
    this.mapOfProcessStepsStatus.set(PlateStatus.WGA_STARTED, [ProcessStep.AMPLIFY_WGA]);
    this.mapOfProcessStepsStatus.set(Action.INCUBATE_WGA_RT, [ProcessStep.AMPLIFY_WGA]);
    this.mapOfProcessStepsStatus.set(Action.INCUBATE_WGA_37C, [ProcessStep.AMPLIFY_WGA]);
    this.mapOfProcessStepsStatus.set(PlateStatus.WGA_COMPLETED, [ProcessStep.AMPLIFY_PGX]);
    this.mapOfProcessStepsStatus.set(PlateStatus.FRAGMENTATION_STARTED, [ProcessStep.FRAGMENT_DNA]);
    this.mapOfProcessStepsStatus.set(Action.INCUBATE_37C, [ProcessStep.FRAGMENT_DNA]);
    this.mapOfProcessStepsStatus.set(Action.INCUBATE_NEG_20C, [ProcessStep.FRAGMENT_DNA]);
    this.mapOfProcessStepsStatus.set(PlateStatus.FRAGMENTATION_COMPLETED, []);
    this.mapOfProcessStepsStatus.set(PlateStatus.PRECIPITATION_STARTED, [ProcessStep.PRECIPITATE_DNA]);
    this.mapOfProcessStepsStatus.set(Action.CENTRIFUGE, [ProcessStep.PRECIPITATE_DNA]);
    this.mapOfProcessStepsStatus.set(Action.STOP_CENTRIFUGATION, [ProcessStep.PRECIPITATE_DNA]);
    this.mapOfProcessStepsStatus.set(Action.QC_CHECK, [ProcessStep.PRECIPITATE_DNA]);
    this.mapOfProcessStepsStatus.set(Action.MAX_DRYING_TIME, [ProcessStep.PRECIPITATE_DNA]);
    this.mapOfProcessStepsStatus.set(Action.STOP_DRYING, [ProcessStep.PRECIPITATE_DNA]);
    this.mapOfProcessStepsStatus.set(PlateStatus.PRECIPITATION_COMPLETED, []);
    this.mapOfProcessStepsStatus.set(PlateStatus.RESUSPENDING_STARTED, [ProcessStep.RESUSPEND_DNA]);
    this.mapOfProcessStepsStatus.set(PlateStatus.RESUSPENDING_COMPLETED, []);
    this.mapOfProcessStepsStatus.set(PlateStatus.DENATURATION_STARTED, [ProcessStep.DENATURATE_DNA]);
    this.mapOfProcessStepsStatus.set(Action.INCUBATE_95C, [ProcessStep.DENATURATE_DNA]);
    this.mapOfProcessStepsStatus.set(Action.INCUBATE_48C, [ProcessStep.DENATURATE_DNA]);
    this.mapOfProcessStepsStatus.set(PlateStatus.DENATURATION_COMPLETED, []);
    this.mapOfProcessStepsStatus.set(PlateStatus.COMPLETLY_TRANSFERED, []);
    this.mapOfProcessStepsStatus.set(PlateStatus.COMPLETED, []);
  }

  getProcessStepLiquidHandler(stepName) {
    let stepsMap = this.isMultiPlateOrDetailedWorkflow() ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;
    let liquidHandler = stepsMap.has(stepName) ? stepsMap.get(stepName).liquidHandler : "";
    if (this.aliquotationLiquidHandler == "") {
      this.aliquotationLiquidHandler = liquidHandler
    }
    return liquidHandler;
  }

  fetchAllActiveMachines(){
    this.masterDataService.getConfigList(this.selectedLabId, "machine", 0, 1000).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.machinesList = results.data;
        this.machinesList.forEach(machine => {
          this.machinesBarcodeMap.set(machine.barcode, machine);
        })
      }
    )
  }

  disableButton(stage: number, stepName: string, actionName: string, actionPos: number): boolean {
    if (!this.multiPlate) {
      if ((!this.selectedPlateStepsMap || this.selectedPlateStepsMap == null || this.selectedPlateStepsMap.size < 1)) {
        return true;
      }
      switch (stage) {
        case ProcessStepStage.start:
          return this.disableProcessStepStart(stepName, this.selectedPlateStepsMap);
        case ProcessStepStage.end:
          return this.disableProcessStepEnd(stepName, this.selectedPlateStepsMap);
        case ProcessStepStage.action:
          return this.disableProcessStepAction(stepName, actionName, actionPos, this.selectedPlateStepsMap);
        default:
          return true;
      }
    }
    return false;
  }

  disableProcessStepStart(stepName: string, selectedPlateStepsMap: Map<string, Step>): boolean {

    let dependentSteps: string[] = this.mapOfProcessStepsFlowAxiom384.get(stepName);
    let disable: boolean = true;
    for (let step of dependentSteps) {
      if (step == ProcessStep.RECEIVE_PLATE) {
        disable = !selectedPlateStepsMap.has(step) || this.isEmptyString(selectedPlateStepsMap.get(step).startPUID) || this.isEmptyDate(selectedPlateStepsMap.get(step).startTimeStamp);
        break;
      }
      let dependentProcessStep = selectedPlateStepsMap.get(step);
      if (dependentProcessStep && !this.isEmptyString(dependentProcessStep.endPUID) && !this.isEmptyDate(dependentProcessStep.endTimeStamp)) {
        disable = false;
      } else {
        disable = true;
        break;
      }
    }
    if (selectedPlateStepsMap.has(stepName)) {
      disable = true;
    }
    return disable;
  }

  disableLynxWorkfile() {
    if (this.multiPlate){
      return false;
    }else{
      if (!this.selectedPlateStepsMap.has(ProcessStep.ALIQUOTATION)) {
        return true;
      }
      let currentProcessStep = this.selectedPlateStepsMap.get(ProcessStep.ALIQUOTATION);
      if (currentProcessStep.endTimeStamp || currentProcessStep.endPUID) {
        return true
      }
      return false
    }
  }

  disableProcessStepAction(stepName: string, actionName: string, actionPos: number, selectedPlateStepsMap: Map<string, Step>): boolean {
    if (!selectedPlateStepsMap.has(stepName)) {
      return true;
    }
    let disable: boolean = true;
    let processStepActions: string[] = this.isMultiPlateOrDetailedWorkflow() ? this.mapOfPopUpProcessStepAndActionAxiom384.get(stepName) : this.mapOfProcessStepAndActionAxiom384.get(stepName);
    let currentProcessStep = selectedPlateStepsMap.get(stepName);
    if (actionPos == 0) {
      disable = currentProcessStep.actionMap.has(actionName);
    } else {
      if (!currentProcessStep.actionMap.has(actionName) && currentProcessStep.actionMap.has(processStepActions[actionPos-1])) {
        disable = false;
      }
    }
    return disable;
  }

  disableProcessStepEnd(stepName: string, selectedPlateStepsMap: Map<string, Step>): boolean {
    if (!selectedPlateStepsMap.has(stepName)) {
      return true;
    }
    let disable: boolean = true;
    let processStepActions: string[] = this.isMultiPlateOrDetailedWorkflow()? this.mapOfPopUpProcessStepAndActionAxiom384.get(stepName): this.mapOfProcessStepAndActionAxiom384.get(stepName);
    let currentProcessStep = selectedPlateStepsMap.get(stepName);
    if (processStepActions && processStepActions.length > 1) {
      let lastAction = processStepActions.slice(-1)[0];
      disable = !currentProcessStep.actionMap.has(lastAction);
    } else if (processStepActions && processStepActions.length > 0) {
      let previousAction = processStepActions[0];
      disable = !currentProcessStep.actionMap.has(previousAction);
    } else {
      disable = false;
    }
    if (!this.isEmptyString(currentProcessStep.endPUID) && this.isEmptyDate(currentProcessStep.endTimeStamp)) {
      disable = true
      return disable
    }
    if (!this.isEmptyString(currentProcessStep.endPUID) && !this.isEmptyDate(currentProcessStep.endTimeStamp)) {
      disable = true;
    }
    return disable;
  }

  isEmptyString(val: string) {
    return (!val || val == null || val === '')
  }

  isEmptyDate(val: Date) {
    return (!val || val == null)
  }

openRequiredPopUpForSomeStatuses(status: string){
    switch(status){
      case Action.CENTRIFUGE:
        this.savePlateStatus(PlateStatus.PRECIPITATION_STARTED, 0, ProcessStep.PRECIPITATE_DNA, "", 0);
        return;
      case PlateStatus.PRECIPITATION_COMPLETED:
        this.savePlateStatus(Action.STOP_DRYING, 2, ProcessStep.PRECIPITATE_DNA, Action.STOP_DRYING, 4);
        return;
      case PlateStatus.WGA_COMPLETED :
        this.savePlateStatus(Action.STOP_INCUBATION_WGA_37C, 2, ProcessStep.AMPLIFY_WGA, Action.STOP_INCUBATION_WGA_37C, 6);
        return;
      case PlateStatus.FRAGMENTATION_COMPLETED:
        this.savePlateStatus(Action.STOP_INCUBATION_NEG_20C, 2, ProcessStep.FRAGMENT_DNA, Action.STOP_INCUBATION_NEG_20C, 5);
        return;
      case PlateStatus.RESUSPENDING_COMPLETED:
        this.savePlateStatus(Action.STOP_SHAKING, 2, ProcessStep.DENATURATE_DNA, Action.STOP_SHAKING, 1);
        return;
      case Action.INCUBATE_95C:
        this.savePlateStatus(PlateStatus.DENATURATION_STARTED, 0, ProcessStep.DENATURATE_DNA, "", 0);
        return;
      case PlateStatus.DENATURATION_COMPLETED:
        this.savePlateStatus(Action.STOP_INCUBATE_48C, 2, ProcessStep.DENATURATE_DNA, Action.STOP_INCUBATE_48C, 3);
        return;
      default: return;
    }
  }

  savePlateStatus(status: string, stage: number, stepName: string, actionName: string, actionPos: number) {
    if (!this.isMultiPlateOrDetailedWorkflow() &&  status != PlateStatus.ALIQUOTATION_COMPLETED) {
      let funtionName = this.mapOfStatusSaves.get(status);
      this[funtionName](status);
    } else {

      this.openRequiredPopUpForSomeStatuses(status);

      this.multiStage = stage;
      this.multiActionName = actionName;
      this.multiActionPos = actionPos;
      this.multiStepName = stepName;
      this.multiUpdateStatus = status;
      this.multiUpdateStatusLabel = this.mapOfStatusAndLabel.has(status) ? this.mapOfStatusAndLabel.get(status) : status;
      if (stage == ProcessStepStage.start) {
          this.multiUpdateButtonStyleClass = "startButton"
      } else if (stage == ProcessStepStage.end) {
        this.multiUpdateButtonStyleClass = "endButton"
      } else if (this.multiUpdateStatusLabel.startsWith("Complete")) {
        this.multiUpdateButtonStyleClass = "endButton"
      } else if (status.startsWith("STOP")) {
        this.multiUpdateButtonStyleClass = "otherbutton"
      }
      else {
        this.multiUpdateButtonStyleClass = "VioletButtons"
      }

      if (PlateStatus.ALIQUOTATION_STARTED == status)
        this.multiLiquidHandler = this.aliquotationLiquidHandler
      else
        this.multiLiquidHandler = '';

      this.enteredPlateId = "";
      this.enteredAliquotPlateId = "";
      this.multiUpdatePlateList = [];

      this.multiUpdatePlateListSave = [];
      this.multiUpdatePlateInfoList = [];

      this.multiUpdateInputLabel = "Scan Plate"

      let popUpValues = this.mapOfStatusAndPopUpValues.get(status);
      this.selectedPopUpString = popUpValues["popUpName"]
      this.multiNextStep = popUpValues["nextStep"]
      this.multiUpdateButtonLabel = popUpValues["buttonLabel"]
      this.setRequiredFields(popUpValues);
    }
  }

  setRequiredFields(popUpValues: any){
    let requiredFields: Array<string> = popUpValues["requiredFields"];
    requiredFields.forEach((field,index) => {
      if(field==PlateIdTypes.LAST_UPDATED_PLATEID){
        this.multiPlateIdRequired[0] = true;
        if(index == 0){
          this.multiPlateIdRequired[1] = true;
          setTimeout(() => {
            this.findAndHighlightElement(this.selectedPopUpString+"-popup-plateid")
          },100);
        }
      }else if(field==PlateIdTypes.ALIQUOT){
        this.multiAliquotPlateIdRequired[0] = true;
        if(index == 0){
          this.multiAliquotPlateIdRequired[1] = true;
          setTimeout(() => {
            this.findAndHighlightElement(this.selectedPopUpString+"-popup-aliquot-plateid");
          }, 100)
        }
      }
    })

    this.multiShakeRequired = popUpValues["shake"];
    this.multiShakeCheckboxValue = !popUpValues["shake"];

    this.multiPreSpinRequired = popUpValues["preSpin"];
    this.multiPreSpinCheckboxValue = !popUpValues["preSpin"];

    this.multiSpinRequired = popUpValues["spin"];
    this.multiSpinCheckboxValue = !popUpValues["spin"];

    this.multiAirDryRequired = popUpValues["airdry"];

    this.multiSealRequired = popUpValues["seal"];
    this.multiSealLiquidHandler = "";

    if(popUpValues["processStepComplete"]){
      this.multiCompleteProcessStep = popUpValues["processStepComplete"]
      this.multiCompleteProcessStepStatus = popUpValues["processStepStatus"]
    }

    this[this.selectedPopUpString] = true;

    let headers = popUpValues["headers"]
    if(this.selectedPopUpString == "popUpWithMachineAndChemicals"){
      this.popUpWithMachineAndChemicalsHeader1 = headers[0]
      this.popUpWithMachineAndChemicalsHeader2 = headers[1]
      this.popUpWithMachineAndChemicalsChemical = headers[2]
      if(this.popUpWithMachineAndChemicalsHeader2=="" || this.popUpWithMachineAndChemicalsChemical == ""){
        this.multiLiquidHandlerRequired = false;
      }

      if(PlateStatus.FRAGMENTATION_STARTED == this.multiUpdateStatus){
        this.multiPopupWithMachineAndChemicalsTableHeader = headers[4]
      }
      this.multiShakeHeader = headers[3];
    }
    else if(this.selectedPopUpString == "showConfirmPlatesPopup"){
      this.showConfirmPlatesPopupHeader1 = headers[0];
      this.showConfirmPlatesPopupHeader2 = headers[1];
      this.showConfirmPlatesPopupHeader3 = headers[2];
    }
    else if(this.selectedPopUpString == "popUpWithDifferentMachine"){
      this.popUpWithDifferentMachineHeader = headers[0];
      this.popUpWithDifferentMachineEquipmentPlaceholder = headers[1];
      setTimeout(() => {
        this.findAndHighlightElement(this.selectedPopUpString+"-popup-machineid")
      },100);
    }
    else if(this.selectedPopUpString == "popUpWithQCCheck"){
      this.popUpWithQCCheckHeader1 = headers[0];
      this.popUpWithQCCheckHeader2 = headers[1];
      setTimeout(() => {
        this.findAndHighlightElement(this.selectedPopUpString+"-popup-aliquot-plateid")
      },100);
    }
  }

  startAliquotation(status: string) {
    if (!this.updateProcessStep(ProcessStep.ALIQUOTATION, ProcessStepStage.start, "", this.aliquotationLiquidHandler)) {
      return;
    }
    if(![PlateStatus.EXTRACTION_COMPLETED,PlateStatus.MERGE_COMPLETED].includes(this.selectedPlate.status)){
      this._messagesService.addErrorMessage({
        severity:"error",summary:'Error while updating plate',
        detail:`${this.selectedPlate.lastUpdatedPlateID} requires Extraction completed or Merge completed to proceed.`
      })
      return;
    }
    this.selectedPlate.status = status;
    this.updatePlate(this.aliquotationLiquidHandler, status);
  }

  completeAliquotation(status: string) {
    if(this.aliquotPlateID == ""){
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Aliquot ID not present',
        detail: "Please add an aliquot plate ID"
      })
      return;
    }
    if (!this.updateProcessStep(ProcessStep.ALIQUOTATION, ProcessStepStage.end, "")) {
      return;
    }
    this.selectedPlate.aliquotPlateID = this.aliquotPlateID
    if(this.selectedPlate.storage && this.selectedPlate.status !== PlateStatus.STORAGE_PLATE){
      this.multiUpdateRestorePlateList.push(this.selectedPlate.lastUpdatedPlateID)
    }
    this.selectedPlate.lastUpdatedPlateID = this.aliquotPlateID
    this.selectedPlate.addNewPlateMeta = true
    this.selectedPlate.status = status;
    this.updatePlate();
  }

  startWGA(status: string) {
    if (!this.updateProcessStep(ProcessStep.AMPLIFY_WGA, ProcessStepStage.start, "")) {
      return;
    }
    this.selectedPlate.status = status;
    this.updatePlate();
  }

  completeWGA(status: string) {
    if (!this.updateProcessStep(ProcessStep.AMPLIFY_WGA, ProcessStepStage.end, "")) {
      return;
    }

    this.selectedPlate.status = status;
    this.updatePlate();
  }

  startPrecipitation(status: string) {
    if (!this.updateProcessStep(ProcessStep.PRECIPITATE_DNA, ProcessStepStage.start, "")) {
      return;
    }
    this.selectedPlate.status = status;
    this.updatePlate();
  }

  completePrecipitation(status: string) {
    if (!this.updateProcessStep(ProcessStep.PRECIPITATE_DNA, ProcessStepStage.end, "")) {
      return;
    }
    this.selectedPlate.status = status;
    this.updatePlate();
  }

  startDenaturation(status: string) {
    if (!this.updateProcessStep(ProcessStep.DENATURATE_DNA, ProcessStepStage.start, "")) {
      return;
    }
    this.selectedPlate.status = status;
    this.updatePlate();
  }

  completeDenaturation(status: string) {
    if (!this.updateProcessStep(ProcessStep.DENATURATE_DNA, ProcessStepStage.end, "")) {
      return;
    }

    this.selectedPlate.status = status;
    this.updatePlate();
  }

  startFragmentation(status: string) {
    if (!this.updateProcessStep(ProcessStep.FRAGMENT_DNA, ProcessStepStage.start, "")) {
      return;
    }
    this.selectedPlate.status = status;
    this.updatePlate();
  }

  completeFragmentation(status: string) {
    if (!this.updateProcessStep(ProcessStep.FRAGMENT_DNA, ProcessStepStage.end, "")) {
      return;
    }
    this.selectedPlate.status = status;
    this.updatePlate();
  }

  startResuspending(status: string) {
    if (!this.updateProcessStep(ProcessStep.RESUSPEND_DNA, ProcessStepStage.start, "")) {
      return;
    }
    this.selectedPlate.status = status;
    this.updatePlate();
  }

  completeResuspending(status: string) {
    if (!this.updateProcessStep(ProcessStep.RESUSPEND_DNA, ProcessStepStage.end, "")) {
      return;
    }

    this.selectedPlate.status = status;
    this.updatePlate();
  }

  actionIncubateWGART(status: string) {
    if (!this.updateProcessStep(ProcessStep.AMPLIFY_WGA, ProcessStepStage.action, status)) {
      return;
    }
    this.updatePlate();
  }

  actionStopIncubationWGART(status: string) {
    if (!this.updateProcessStep(ProcessStep.AMPLIFY_WGA, ProcessStepStage.action, status)) {
      return;
    }
    this.updatePlate();
  }

  actionIncubateWGA37c(status: string) {
    if (!this.updateProcessStep(ProcessStep.AMPLIFY_WGA, ProcessStepStage.action, status)) {
      return;
    }
    this.updatePlate();
  }

  actionStopIncubationWGA37c(status: string) {
    if (!this.updateProcessStep(ProcessStep.AMPLIFY_WGA, ProcessStepStage.action, status)) {
      return;
    }
    this.updatePlate();
  }

  actionIncubate37c(status: string) {
    if (!this.updateProcessStep(ProcessStep.FRAGMENT_DNA, ProcessStepStage.action, status)) {
      return;
    }
    this.updatePlate();
  }

  actionStopIncubation37c(status: string) {
    if (!this.updateProcessStep(ProcessStep.FRAGMENT_DNA, ProcessStepStage.action, status)) {
      return;
    }
    this.updatePlate();
  }

  actionShaking(status: string){
    if (!this.updateProcessStep(ProcessStep.RESUSPEND_DNA, ProcessStepStage.action, status)) {
      return;
    }
    this.updatePlate();
  }
  actionStopShaking(status: string){
    if (!this.updateProcessStep(ProcessStep.RESUSPEND_DNA, ProcessStepStage.action, status)) {
      return;
    }
    this.updatePlate();
  }


  actionIncubateNeg20c(status: string) {
    if (!this.updateProcessStep(ProcessStep.FRAGMENT_DNA, ProcessStepStage.action, status)) {
      return;
    }
    this.updatePlate();
  }

  actionStopIncubationNeg20c(status: string) {
    if (!this.updateProcessStep(ProcessStep.FRAGMENT_DNA, ProcessStepStage.action, status)) {
      return;
    }
    this.updatePlate();
  }

  actionCentrifuge(status: string) {
    if (!this.updateProcessStep(ProcessStep.PRECIPITATE_DNA, ProcessStepStage.action, status)) {
      return;
    }
    this.updatePlate();
  }

  actionStopCentrifugation(status: string) {
    if (!this.updateProcessStep(ProcessStep.PRECIPITATE_DNA, ProcessStepStage.action, status)) {
      return;
    }
    this.updatePlate();
  }

  actionMaxDryingTime(status: string) {
    if (!this.updateProcessStep(ProcessStep.PRECIPITATE_DNA, ProcessStepStage.action, status)) {
      return;
    }
    this.updatePlate();
  }

  actionStopDrying(status: string) {
    if (!this.updateProcessStep(ProcessStep.PRECIPITATE_DNA, ProcessStepStage.action, status)) {
      return;
    }
    this.updatePlate();
  }

  actionIncubate95c(status: string) {
    if (!this.updateProcessStep(ProcessStep.DENATURATE_DNA, ProcessStepStage.action, status)) {
      return;
    }
    this.updatePlate();
  }

  actionStopIncubate95c(status: string){
    if(!this.updateProcessStep(ProcessStep.DENATURATE_DNA,ProcessStepStage.action,status)){
      return;
    }
    this.updatePlate();
  }

  actionIncubate48c(status: string) {
    if (!this.updateProcessStep(ProcessStep.DENATURATE_DNA, ProcessStepStage.action, status)) {
      return;
    }
    this.updatePlate();
  }

  actionStopIncubate48c(status: string){
    if (!this.updateProcessStep(ProcessStep.DENATURATE_DNA, ProcessStepStage.action, status)) {
      return;
    }
    this.updatePlate();
  }

  updateProcessStep(step: string, stage: ProcessStepStage, actionName: string, liquidHandler: string = ""): boolean {
    if (this.selectedPlateStepsMap.has(step)) {
      var existingStep = this.selectedPlate.processSteps.find(s => s.step == step);
      if (ProcessStepStage.start == stage) {
        existingStep.startTimeStamp = new Date();
        existingStep.startPUID = this.puid;
        existingStep.liquidHandler = liquidHandler;
      } else if (ProcessStepStage.end == stage) {
        existingStep.endTimeStamp = new Date();
        existingStep.endPUID = this.puid;
      } else {
        if (existingStep.actionMap.has(actionName)) {
          var existingAction = existingStep.action.find(a => a.action == actionName);
          existingAction.actionPUID = this.puid;
          existingAction.actionStartTime = new Date();
        } else {
          existingStep.action = (!existingStep.action || existingStep.action == null) ? [] : existingStep.action;
          var newAction = new StepAction();
          newAction.action = actionName;
          newAction.actionPUID = this.puid;
          newAction.actionStartTime = new Date();
          newAction.actionRunTime = this.mapOfActionRuntimeAxiom384.get(actionName);
          existingStep.action.push(newAction);
        }
      }
    } else {
      this.selectedPlate.processSteps = (!this.selectedPlate.processSteps || this.selectedPlate.processSteps == null) ? [] : this.selectedPlate.processSteps;
      var newStep = new Step();
      newStep.step = step;
      if (ProcessStepStage.start == stage) {
        newStep.startTimeStamp = new Date();
        newStep.startPUID = this.puid;
        newStep.liquidHandler = liquidHandler;
        //server is forcing to put default/dummy values, otherwise it is throwing 500
        newStep.endPUID = "";
        newStep.endTimeStamp = null;
        newStep.action = [];
        newStep.chemicals = [];

      } else {
        this._messagesService.addWarningMessage({
          severity: 'warn', summary: 'Action not allowed',
          detail: 'Process has to be started to perform this action'
        })
        return false;
      }
      this.selectedPlate.processSteps.push(newStep)
    }
    return true;
  }

  updateMultiPlateUpdateProcessStep(step: string, stage: ProcessStepStage, actionName: string, liquidHandler = "") {
    if (this.multiUpdateProcessStepsMap.has(step)) {
      var existingStep = this.multiUpdateProcessStepsMap.get(step);
      if (ProcessStepStage.start == stage) {
        existingStep.startTimeStamp = new Date();
        existingStep.startPUID = this.puid;
      } else if (ProcessStepStage.end == stage) {
        existingStep.endTimeStamp = new Date();
        existingStep.endPUID = this.puid;
      } else {
        if (existingStep.actionMap.has(actionName)) {
          var existingAction = existingStep.action.find(a => a.action == actionName);
          existingAction.actionPUID = this.puid;
          existingAction.actionStartTime = new Date();
        } else {
          existingStep.action = (!existingStep.action || existingStep.action == null) ? [] : existingStep.action;
          var newAction = new StepAction();
          newAction.action = actionName;
          newAction.actionPUID = this.puid;
          newAction.actionStartTime = new Date();
          newAction.actionRunTime = this.mapOfActionRuntimeAxiom384.get(actionName);
          existingStep.action.push(newAction);
          existingStep.actionMap.set(actionName, newAction)
        }
      }
    } else {
      var newStep = new Step();
      newStep.step = step;
      newStep.action = [];
      newStep.actionMap = new Map();
      if (ProcessStepStage.start == stage) {
        newStep.startTimeStamp = new Date();
        newStep.startPUID = this.puid;
        newStep.liquidHandler = liquidHandler;
      } else if (ProcessStepStage.end == stage) {
        newStep.endTimeStamp = new Date();
        newStep.endPUID = this.puid;
      } else {
        var newAction = new StepAction();
        newAction.action = actionName;
        newAction.actionPUID = this.puid;
        newAction.actionStartTime = new Date();
        newAction.actionRunTime = this.mapOfActionRuntimeAxiom384.get(actionName);
        newStep.action.push(newAction);
        newStep.actionMap.set(actionName, newAction);
      }
      this.multiUpdateProcessStepsMap.set(step, newStep)
    }
  }

  restorePlatesFromStorage(plates:string[] = [], callBack: () => void){
    let body = {
      "labid":this.selectedLabId,
      "plateids":plates
    }
    this.blocked = true
    this._maStorageService.removeMultiplePlatesFromStorage(body).subscribe(
      _result => {
        this.blocked = false
        let data = {
          'plateIDs':plates
        }
        this.blocked = true
        this._maStorageService.restorePlatesFromStorage(this.selectedLabId,data).subscribe(
          _result => {
            this.blocked = false
            this.multiUpdateRestorePlateList = []
            callBack()
          },
          error => {
            this.blocked = false
            callBack()
            this._messagesService.addErrorMessage({
              severity:'error',summary:'Something went wrong while restoration',
              detail:error
            })
          }
        )
      },
      error => {
        this.blocked = false
        callBack()
        this._messagesService.addErrorMessage({
          severity:'error',summary:'Something went wrong while restoration',
          detail:error
        })
      }
    )
  }

  updatePlate(liquidHandler: string = "", status: string = "") {
    if (!this.isPUIDPresent()) {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before moving ahead',
      });
      return;
    }
    if(this.multiUpdateRestorePlateList.length !== 0){
      this.selectedPlate.version+=1
      this.restorePlatesFromStorage(this.multiUpdateRestorePlateList,() => {
        this.callBackUpdatePlate(liquidHandler,status)
      })
      return
    }
    else if(this.selectedPlate.storagePlate && this.selectedPlate.status !== PlateStatus.STORAGE_PLATE){
      this.selectedPlate.version+=1
      this.restorePlatesFromStorage([this.selectedPlate.lastUpdatedPlateID], () => {
        this.callBackUpdatePlate(liquidHandler,status)
      })
      return
    }
    this.callBackUpdatePlate(liquidHandler,status)
  }

  callBackUpdatePlate(liquidHandler: string = "",status:string = ""){
    this.blocked = true;
    this.platePreparationService.updatePlate(this.selectedPlate.plateID, this.selectedPlate, this.selectedLabId).subscribe({
      next : (result) => {
        this.blocked = false;
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Plate ' + this.selectedPlate.plateID + ' is updated',
          detail: this.selectedPlate.plateID + ' has been updated successfully with requested status'
        })
        this.selectedPlate = result;
        this.prepareProcessStepsMap();
        this.updatePlateDataEmitter.emit(this.selectedPlate);
        if (liquidHandler != "" && status != "")
          this.updateMachine(liquidHandler, status, this.selectedPlate.workFlow);
        liquidHandler = "";
        status = "";
      },error: (error: any) => {
        this.blocked = false;
        this.showError(error);
      }
    })
  }

  searchForPlateAction(plateID: string) {
    this.blocked = true;
    this.platePreparationService.fetchPlate(plateID, this.selectedLabId).subscribe(
      (result) => {
        this.blocked = false;
        this.selectedPlate = result;
        this.multiPlate = false;
        this.aliquotPlateID = this.selectedPlate.aliquotPlateID;
        if(this.selectedPlate.storagePlate && this.selectedPlate.status !== PlateStatus.STORAGE_PLATE){
          this.restorePlatesFromStorage([this.selectedPlate.plateID],() => {})
        }
        this.updatePlateDataEmitter.emit(this.selectedPlate);
        if(PlateStatus.PLATE_REDO == this.selectedPlate.status){
          return;
        }
        this.prepareProcessStepsMap();
      }, (error) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to fetch plate info',
          detail: error.error
        })
      }
    )
  }

  prepareProcessStepsMap() {
    this.selectedPlateStepsMap.clear();
    if (!this.selectedPlate.processSteps || this.selectedPlate.processSteps == null)
      return;
    this.selectedPlate.processSteps.forEach(step => {
      step.actionMap = new Map();
      step.action.forEach(s => {
        step.actionMap.set(s.action, s);
      })
      this.selectedPlateStepsMap.set(step.step, step);
    }
    )
  }

  prepareProcessStepMapforMultiPlateUpdate(selectedPlate: Plate) {
    this.multiPlateStepsMap = new Map();
    if (!selectedPlate.processSteps || selectedPlate.processSteps == null)
      return;
    selectedPlate.processSteps.forEach(step => {
      step.actionMap = new Map();
      step.action.forEach(s => {
        step.actionMap.set(s.action, s);
      })
      this.multiPlateStepsMap.set(step.step, step);
    });
    this.multiPlateStepsMapList.push(this.multiPlateStepsMap);
  }

  updateMachine(barcode, status, workFlow) {
    if (barcode != '' || barcode == null) {
      let selectedMachine = this.machinesList.find(element => barcode === element.barcode);
      if (selectedMachine !== undefined) {
        selectedMachine.latestProcessStep = this.machineProcessStepStatusMap.get(status);
        selectedMachine.latestProcessStepTimeStamp = new Date();
        selectedMachine.latestWorkFlow = workFlow;
        this.blocked = false;
        this.masterDataService.updateConfig(selectedMachine.lab, selectedMachine, "machine").subscribe(
          results => {
            this.blocked = false;
            if (!results) {
              return;
            }
            this.machinesList[this.machinesList.indexOf(selectedMachine)] = results.data
          },
          error => {
            this.blocked = false;
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Error in updating Machine',
              detail: "Error in updating machine status."
            });
          }
        );
      }
      else {
        this._messagesService.addWarningMessage({
          severity: 'warn', summary: 'Machine Does Not Exists',
          detail: "Machine with the given barcode does not exist."
        });
      }
    }
  }

  downloadLynxFile() {
    const sampleVolume = {}
    for (let i = 0; i < this.processFlows.length; i++) {
        sampleVolume[this.processFlows[i]['processFlowName']] = this.processFlows[i]['aliqoutVolume'] == undefined || String(this.processFlows[i]['aliqoutVolume']) == "" || !('aliqoutVolume' in this.processFlows[i]) ? 10 : Number(this.processFlows[i]['aliqoutVolume'])
    }
    this.blocked = true;
    this.platePreparationService.downloadLynxWorkfile(this.selectedLabId, sampleVolume).subscribe({
        next: (lynxWorkFile) => {
            this.blocked = false;
            this._messagesService.addSuccessMessage({
                severity: 'success', summary: 'Workfile Generated Successfully',
                detail: "Lynx Workfile downloaded successfully"
            });
            saveByFileSaver(lynxWorkFile.fileContent, lynxWorkFile.filename);
        }, error: (_error) => {
            this.blocked = false;
            this._messagesService.addErrorMessage({
                severity: 'error', summary: 'Workfile not generated',
                detail: "Lynx workfile generation failed"
            });
        }
    });
  }

  getAllProcessFlows() {
    this.blocked = true;
    this.masterDataService.getConfigList(this.selectedLabId, 'processFlow', 0, 100, true).subscribe(results => {
      this.blocked = false;
      if (results && results.data) {
        this.processFlows = results.data;
      }
    }, error => {
      this.blocked = false;
      this.showError(error);
    })
  }

  isPUIDPresent() {
    if (this.puid != null && this.puid != undefined && this.puid != '') {
      return true;
    }
    return false;
  }

  findAndHighlightElement(elementId) {
    let element = document.getElementById(elementId);
    if (element) {
      element.focus();
    }
  }

  isValidProcessStep(stepName: string): boolean {
    let stepsMap = this.multiPlate ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;
    return (stepsMap.get(stepName) != undefined && stepsMap.get(stepName) != null);
  }

  isValidProcessStepAction(stepName: string) {
    let stepsMap = this.multiPlate ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;
    return (stepsMap.get(stepName) != undefined && stepsMap.get(stepName) != null);
  }

  getProcessStepStartPuid(stepName: string): string {
    let stepsMap = this.multiPlate ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;
    return stepsMap.get(stepName).startPUID;
  }

  getProcessStepEndPuid(stepName: string): string {
    let stepsMap = this.multiPlate ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;
    return stepsMap.get(stepName).endPUID;
  }

  getProcessStepStartTimestamp(stepName: string): Date {
    let stepsMap = this.multiPlate ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;
    return this.multiPlate ? stepsMap.get(stepName).startTimeStamp : this.convertUtcToLocal(stepsMap.get(stepName).startTimeStamp);
  }

  getProcessStepEndTimestamp(stepName: string): Date {
    let stepsMap = this.multiPlate ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;
    return this.multiPlate ? stepsMap.get(stepName).endTimeStamp : this.convertUtcToLocal(stepsMap.get(stepName).endTimeStamp);
  }

  getProcessStepActionPuid(stepName: string, actionName: string) {
    let stepsMap = this.multiPlate ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;
    return stepsMap.get(stepName).actionMap.get(actionName).actionPUID;
  }

  getProcessStepActionTimeStamp(stepName: string, actionName: string) {
    let stepsMap = this.multiPlate ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;
    return this.multiPlate ? stepsMap.get(stepName).actionMap.get(actionName).actionStartTime : this.convertUtcToLocal(stepsMap.get(stepName).actionMap.get(actionName).actionStartTime);
  }

  isValidProcessStepActionPerformed(stepName: string, actionName: string){
    let stepsMap = this.multiPlate ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;
    return ( stepsMap.get(stepName) && stepsMap.get(stepName).actionMap.get(actionName));
  }

  calculateRemainingTimeForAction(stepName: string, actionName: string) {
    let stepsMap = this.multiPlate ? this.multiUpdateProcessStepsMap : this.selectedPlateStepsMap;
    if (stepsMap.get(stepName).actionMap && stepsMap.get(stepName).actionMap.get(actionName) != undefined && stepsMap.get(stepName).actionMap.get(actionName) != null) {
      let actionStartTime: Date = this.getProcessStepActionTimeStamp(stepName, actionName);
      let actionRunTime: number = stepsMap.get(stepName).actionMap.get(actionName).actionRunTime;
      if(actionName.startsWith("STOP")){
        return this.returnCalculatingTimeForStopAction(actionName, actionStartTime, stepName)
      }else{
        return this.calculatingTimes(this.calculateRemainingTime(actionRunTime, actionStartTime));
      }
    }
    else {
      let actionRunTime = this.mapOfActionRuntimeAxiom384.get(actionName);
      return this.calculatingTimes(actionRunTime * 60);
    }
  }

  returnCalculatingTimeForStopAction(actionName, actionStartTime, stepName){
    if(actionName == Action.STOP_INCUBATION_WGA_RT){
      return this.calculatingTimes((actionStartTime.getTime() - this.getProcessStepActionTimeStamp(stepName, Action.INCUBATE_WGA_RT).getTime())/1000)
    }
    if(actionName == Action.STOP_INCUBATION_WGA_37C){
      return this.calculatingTimes((actionStartTime.getTime() - this.getProcessStepActionTimeStamp(stepName, Action.INCUBATE_WGA_37C).getTime())/1000)
    }
    if(actionName == Action.STOP_INCUBATION_NEG_20C){
      return this.calculatingTimes((actionStartTime.getTime() - this.getProcessStepActionTimeStamp(stepName, Action.INCUBATE_NEG_20C).getTime())/1000)
    }
    if(actionName == Action.STOP_INCUBATION_37C){
      return this.calculatingTimes((actionStartTime.getTime() - this.getProcessStepActionTimeStamp(stepName, Action.INCUBATE_37C).getTime())/1000)
    }
    if(actionName == Action.STOP_DRYING){
      return this.calculatingTimes((actionStartTime.getTime() - this.getProcessStepActionTimeStamp(stepName, Action.MAX_DRYING_TIME).getTime())/1000)
    }
    if(actionName == Action.STOP_CENTRIFUGATION){
      return this.calculatingTimes((actionStartTime.getTime() - this.getProcessStepActionTimeStamp(stepName, Action.CENTRIFUGE).getTime())/1000)
    }
    if(actionName == Action.STOP_SHAKING){
      return this.calculatingTimes((actionStartTime.getTime() - this.getProcessStepActionTimeStamp(stepName,Action.SHAKING).getTime())/1000)
    }
    if(actionName == Action.STOP_INCUBATE_95C){
      return this.calculatingTimes((actionStartTime.getTime() - this.getProcessStepActionTimeStamp(stepName,Action.INCUBATE_95C).getTime())/1000)
    }
    if(actionName == Action.STOP_INCUBATE_48C){
      return this.calculatingTimes((actionStartTime.getTime() - this.getProcessStepActionTimeStamp(stepName,Action.INCUBATE_48C).getTime())/1000)
    }
  }

  calculatingTimes(timeLeftInSecs: number) {
    let timeLeft = Math.floor(timeLeftInSecs);
    if (timeLeft == 0)
      return "00:00:00";
    let sec = 0, min = 0, hr = 0
    if (timeLeft % 60 != 0) {
      sec = timeLeft % 60;
      timeLeft = timeLeft - sec;
    }
    timeLeft = timeLeft / 60;
    if (timeLeft % 60 != 0) {
      min = timeLeft % 60;
      timeLeft = timeLeft - min;
    }
    timeLeft = timeLeft / 60;
    hr = timeLeft;
    let secStr = "00" + sec, minStr = "00" + min, hrStr = "00" + hr
    return hrStr.substring(hrStr.length - 2) + ':' + minStr.substring(minStr.length - 2) + ":" + secStr.substring(secStr.length - 2);
  }

  calculateRemainingTime(actionRunTime: number, actionStartTime: Date) {
    let currentDateLocal = new Date();
    if (actionStartTime.getTime() + actionRunTime * 60 * 1000 <= currentDateLocal.getTime()) {
      return 0;
    }
    return (actionStartTime.getTime() + actionRunTime * 60 * 1000 - currentDateLocal.getTime()) / 1000;
  }

  convertUtcToLocal(date: Date): Date {
    if (!date || date == null) return;
    var offset = new Date().getTimezoneOffset();
    let dateInLocal = new Date(date);
    dateInLocal.setMinutes(dateInLocal.getMinutes() - offset);
    return dateInLocal;
  }

  getStorageLocations() {
    this._maStorageService.fetchActiveStorageLocations(this.selectedLabId, "RECOMBINE_DNA").subscribe(
      (result) => {
        this.storageList = result.datalist;
        if (this.storageList.length === 1) {
          this.selectedStorage = this.storageList[0];
        }
      }
    )
  }

  showError(error: any) {
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  onFileSelectLynx(filesData) {
    if (filesData.target.files.length > 0) {
      const fileLynx = filesData.target.files[0];
      this.uploadedLynxFile = fileLynx;
      let lynxFileReader: FileReader = new FileReader();
      let self = this
      lynxFileReader.onloadend = function (x) {
        self.uploadedLynxFileContent = lynxFileReader.result
        self.isLynxFileNotSelected = false
      }
      lynxFileReader.readAsText(fileLynx)
    } else {
      this.isLynxFileNotSelected = true;
    }
  }

  lynxFileUpload() {
    this.blocked = true;
    const formData = new FormData();
    formData.append('file', this.uploadedLynxFile);
    formData.append('labid', this.selectedLabId);
    formData.append('puid', this.puid);
    this.platePreparationService.uploadLynxWorkfile(formData).subscribe({
      next: (underFilledPlates) => {
        this.blocked = false;
        const severity = underFilledPlates > 0 ? "error" : "success";
        let message = "Lynx file has been uploaded successfully."
        if(severity === "error"){
          message+= `There were ${underFilledPlates} under filled plates which were updated using Aliquot Lynx file.`
        }
        this._messagesService.addSuccessMessage({
          severity: severity, summary: 'Lynx file uploaded successfully!!!',detail:message
        });
        this.lynxFileUploadElement.nativeElement.value = "";
        this.isLynxFileNotSelected = true;
        if (this.selectedPlate.plateID) {
          this.searchForPlateAction(this.selectedPlate.plateID);
        }
        this.reloadPlateTableEmitter.emit();
      }
      ,
      error: (error) => {
        this.lynxFileUploadElement.nativeElement.value = "";
        this.isLynxFileNotSelected = true;
        this.blocked = false;
        this.showError(error)
      }
    });
  }

  onFileSelectPrecell(filesData) {
    if (filesData.target.files.length > 0) {
      const filePrecell = filesData.target.files[0];
      this.uploadedPrecellFile = filePrecell;
      let precellFileReader: FileReader = new FileReader();
      let self = this
      precellFileReader.onloadend = function(x) {
        self.uploadedPrecellFileContent = precellFileReader.result
        self.isPrecellFileNotSelected = false
      }
      precellFileReader.readAsText(filePrecell)
    } else {
      this.isPrecellFileNotSelected = true;
    }
  }

  addDenatChemicalLot(){
    if(this.precellChemical1 == ""){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Lot is empty',
        detail: "Please enter a valid Lot value"
      });
      return
    }
    this.multiDenatChemicalLotList.push(this.precellChemical1)
    this.precellChemical1 = ""
  }

  deleteDenatLotValue(index){
    this.multiDenatChemicalLotList.splice(index,1);
  }


  addNeutChemicalLot(){
    if(this.precellChemical2 == ""){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Lot is empty',
        detail: "Please enter a valid Lot value"
      });
      return
    }
    this.multiNeutChemicalLotList.push(this.precellChemical2)
    this.precellChemical2 = ""
  }

  deleteNeutLotValue(index){
    this.multiNeutChemicalLotList.splice(index,1);
  }

  addAmpChemicalLot(){
    if(this.precellChemical3 == ""){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Lot is empty',
        detail: "Please enter a valid Lot value"
      });
      return
    }
    this.multiAmpChemicalLotList.push(this.precellChemical3)
    this.precellChemical3 = ""
  }

  deleteAmpLotValue(index){
    this.multiAmpChemicalLotList.splice(index,1);
  }

  precellFileUpload() {
    this.blocked = true;
    let formData = new FormData();
    let chemicals:any = {
      "AMPLIFY_WGA" : {
        "chemical":"Denat. Solution",
        "lots": this.multiDenatChemicalLotList
      },
      "NEUTRALIZATION" : {
        "chemical":"Neut. Solution",
        "lots": this.multiNeutChemicalLotList
      },
      "AMPLIFICATION" : {
        "chemical":"Ampl. MasterMix",
        "lots": this.multiAmpChemicalLotList
      }
    }
    formData.append('file', this.uploadedPrecellFile);
    formData.append('timezoneOffset', new Date().getTimezoneOffset().toString());
    formData.append('puid', this.puid);
    formData.append("chemical", JSON.stringify(chemicals));
    this.platePreparationService.uploadPrecellLogfile(formData, this.selectedLabId).subscribe(
      results => {
        this.blocked = false;
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: "Precell file uploaded successfully", detail: results.data
        });
        this.resetPrecellValues();
        if(this.selectedPlate.plateID){
          this.searchForPlateAction(this.selectedPlate.plateID);
        }
        this.reloadPlateTableEmitter.emit();
      },
      error => {
        this.blocked = false;
        this.resetPrecellValues()
        this.showError(error)
      }
    );
  }

  resetPrecellValues(){
    this.precellFileUploadElement.nativeElement.value = "";
    this.precellChemical1 = "";
    this.precellChemical2 = "";
    this.precellChemical3 = "";
    this.precellPopupWorkfile = true;
    this.isPrecellFileNotSelected = true;
    this.showPrecellPlatesPopup = false;
    this.isPrecellFileNotSelected = true;
    this.uploadedPrecellFile = null;
    this.uploadedPrecellFileContent = null;
    this.precellPlateList = [];
    this.precellPlateData = [];
  }

  showChemicalPopup(processStep?: string) {
    this.selectedProcessStep = processStep;
    this.masterDataService.getAllActiveChemicals(this.selectedLabId, "chemical").subscribe({
      next : (result) => {
        this.processStepChemicals = result.data.filter(chemical => (chemical.processStep === processStep));
      }, error: (error: any) => {
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error });
      }});

    if (this.selectedPlate.status && !this.mapOfProcessStepsStatus.get(this.selectedPlate.status).includes(processStep) || this.selectedPlate.status == null) {
      this.noChemicalEdit = true;
    } else {
      this.noChemicalEdit = false;
    }

    if (this.lastUpdatedStatus && this.multiPlate && this.mapOfProcessStepsStatus.get(this.lastUpdatedStatus).includes(processStep) && this.lastUpdatedStatus != null && this.lastUpdatedStatus != '') {
      this.multiChemicalEdit = true;
    } else {
      this.multiChemicalEdit = false;
    }

    this.showDialogue = true;
  }

  hideChemicalDialog(plate: Plate) {
    this.showDialogue = false;
    if (plate.plateID !== undefined){
      this.searchForPlateAction(plate.plateID)
    }
  }

  resetPlateIDs(multiUpdatePlateType){
    if(this.multiUpdateStatus === Action.INCUBATE_95C || this.multiUpdateStatus == PlateStatus.DENATURATION_STARTED){
      this.multiLiquidHandler = ""
      this.multiUpdatePlateList = []
      this.findAndHighlightElement('popUpWithDifferentMachine-popup-machineid')
    }
    if(PlateIdTypes.LAST_UPDATED_PLATEID == multiUpdatePlateType){
      this.enteredPlateId = "";
    }else if(PlateIdTypes.ALIQUOT == multiUpdatePlateType){
      this.enteredAliquotPlateId = "";
    }
  }

  checkPlate(multiUpdatePlateType: string = PlateIdTypes.LAST_UPDATED_PLATEID, firstMatchCondition: boolean = true) {
    if (!firstMatchCondition) {
      return this.checkPlateExists(multiUpdatePlateType);
    }

    let plateIDToBeChecked: string;
    if ("popUpWithDifferentMachine" === this.selectedPopUpString && (this.multiLiquidHandler === undefined || this.multiLiquidHandler === '')) {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Machine id is empty',
        detail: 'Please provide the appropiate machine id to proceed'
      })
      this.findAndHighlightElement('popUpWithDifferentMachine-popup-machineid')
      return;
    }

    if (PlateIdTypes.LAST_UPDATED_PLATEID == multiUpdatePlateType) {
      plateIDToBeChecked = this.enteredPlateId.trim();
    } else if (PlateIdTypes.ALIQUOT == multiUpdatePlateType) {
      plateIDToBeChecked = this.enteredAliquotPlateId.trim();
    }

    if (this.checkNullAndUndefined(plateIDToBeChecked) && this.checkNullAndUndefined(this.multiUpdatePlateList) && this.multiUpdatePlateList.includes(plateIDToBeChecked)) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Duplicate Plate', detail: 'Plate already Scanned.' });
      this.resetPlateIDs(multiUpdatePlateType);
      plateIDToBeChecked = undefined;
      return;
    }

    if (this.checkNullAndUndefined(plateIDToBeChecked) && this.checkNullAndUndefined(this.multiUpdatePlateList) && this.multiUpdatePlateList.length > 20) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Max Plates Reached', detail: '20 Plates already Scanned.' });
      this.resetPlateIDs(multiUpdatePlateType);
      plateIDToBeChecked = undefined;
      return;
    }

    if (this.checkNullAndUndefined(plateIDToBeChecked) && plateIDToBeChecked.trim() == "") {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Empty Plate', detail: 'Please scan a Plate.' });
      this.resetPlateIDs(multiUpdatePlateType);
      plateIDToBeChecked = undefined;
      return;
    }

    this.blocked = true;
    this.platePreparationService.processDetailsbyPlateId(this.selectedLabId, plateIDToBeChecked, multiUpdatePlateType).subscribe(
      (result) => {
        this.blocked = false;
        this.fetchedPlate = result;
        this.prepareProcessStepMapforMultiPlateUpdate(this.fetchedPlate);

        let notEligible = this.eligiblePlate(this.multiStage, this.multiStepName, this.multiActionName, this.multiActionPos);
        if (notEligible) {
          this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Plate Not eligible', detail: 'Please scan a diffrent Plate.' });
          this.resetPlateIDs(multiUpdatePlateType);
          plateIDToBeChecked = "";
          return;
        }

        if (this.fetchedPlate.storagePlate && this.fetchedPlate.status !== PlateStatus.STORAGE_PLATE) {
          this.multiUpdateRestorePlateList.push(this.fetchedPlate.lastUpdatedPlateID)
        }

        this.multiUpdateSelectedWorkFlow = this.fetchedPlate.workFlow;

        if (PlateStatus.ALIQUOTATION_COMPLETED == this.multiUpdateStatus) {
          setTimeout(() => {
            this.findAndHighlightElement(this.selectedPopUpString + "-popup-aliquot-plateid")
          }, 100);
          if(result.samples.length < 96) {
            this.underFilledPlate.add(result.lastUpdatedPlateID);
            this._messagesService.addErrorMessage({
              severity:'error',
              summary:'Under filled plate scanned!!!',
              detail:`Plate ${result.lastUpdatedPlateID} is an under filled plate.Current under filled plate count: ${this.underFilledPlate.size}`
            });
          }
          return;
        }

        if ("popUpWithDifferentMachine" == this.selectedPopUpString) {
          let plateUpdateInfo = new PlateUpdateInfo()
          plateUpdateInfo.plateID = this.fetchedPlate.plateID;
          plateUpdateInfo.lastUpdatedPlateID = plateIDToBeChecked;
          if (PlateIdTypes.ALIQUOT == multiUpdatePlateType) {
            plateUpdateInfo.aliquotPlateID = plateIDToBeChecked;
          }
          plateUpdateInfo.liquidHandler = this.multiLiquidHandler;
          plateUpdateInfo.chemicals = [];

          if (PlateStatus.PRECIPITATION_STARTED == this.multiUpdateStatus) {
            plateUpdateInfo.addFirstAction = {
              "name": Action.CENTRIFUGE,
              "runTime": this.mapOfActionRuntimeAxiom384.get(Action.CENTRIFUGE),
              "liquidHandler": this.multiLiquidHandler
            }
          }
          else if (PlateStatus.DENATURATION_STARTED == this.multiUpdateStatus) {
            plateUpdateInfo.addFirstAction = {
              "name": Action.INCUBATE_95C,
              "runTime": this.mapOfActionRuntimeAxiom384.get(Action.INCUBATE_95C),
              "liquidHandler": this.multiLiquidHandler
            }
          }
          this.multiUpdatePlateList.unshift(plateIDToBeChecked);
          this.multiUpdatePlateInfoList.unshift(plateUpdateInfo)
          this.multiUpdatePlateListSave.unshift(this.fetchedPlate.plateID);
          this.resetPlateIDs(multiUpdatePlateType);
          plateIDToBeChecked = "";
          return;
        }
        this.multiUpdatePlateList.unshift(plateIDToBeChecked);
        this.multiUpdatePlateListSave.unshift(this.fetchedPlate.plateID);
        this.resetPlateIDs(multiUpdatePlateType);
        plateIDToBeChecked = ""
        return;
      },
      (_error) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: "error", summary: "Plate not found!",
          detail: "Plate not found with plate id - " + plateIDToBeChecked
        })
        this.resetPlateIDs(multiUpdatePlateType);
        plateIDToBeChecked = "";
      }
    )
  }
  checkPlateExists(plateIDType: string) {
    let plateIDToBeChecked: string;
    if(PlateIdTypes.ALIQUOT == plateIDType){
      plateIDToBeChecked = this.enteredAliquotPlateId;
    }

    if(plateIDToBeChecked.trim()=="") {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Empty Plate', detail: 'Please scan a Plate.' });
      return;
    }

    if(plateIDToBeChecked && (this.multiUpdatePlateInfoList.find(plate =>plate.aliquotPlateID == plateIDToBeChecked))){
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Duplicate Plate', detail: 'Plate already Scanned.' });
      this.resetPlateIDs(plateIDType);
      plateIDToBeChecked = undefined;
      return;
    }

    this.blocked = true;
    this.platePreparationService.fetchPlate(plateIDToBeChecked,this.selectedLabId).subscribe(
      (_result)=>{
        this.blocked = false;
        this._messagesService.addErrorMessage({ severity: 'error', summary: plateIDType+' Plate Already Exists!', detail: "Please scan a new "+plateIDType+" plateId" });
        if(PlateIdTypes.LAST_UPDATED_PLATEID == plateIDType){
          this.enteredPlateId = "";
          this.findAndHighlightElement(this.selectedPopUpString+'-popup-plateid');
        }else if(PlateIdTypes.ALIQUOT == plateIDType){
          this.enteredAliquotPlateId = "";
          this.findAndHighlightElement(this.selectedPopUpString+'-popup-aliquot-plateid');
        }

      },
      (_error)=>{
        this.blocked = false;
        if(PlateIdTypes.ALIQUOT == plateIDType){
          let plateUpdateInfo = new PlateUpdateInfo()
          plateUpdateInfo.plateID = this.fetchedPlate.plateID;
          plateUpdateInfo.lastUpdatedPlateID = this.enteredPlateId;
          plateUpdateInfo.aliquotPlateID = plateIDToBeChecked;
          this.multiUpdatePlateInfoList.unshift(plateUpdateInfo);
          this.multiUpdatePlateListSave.unshift(this.fetchedPlate.plateID);
          this.enteredPlateId = "";
          this.enteredAliquotPlateId = "";
          this.findAndHighlightElement(this.selectedPopUpString+'-popup-plateid');
          return;
        }
      })

  }

  deleteValue(index) {
    this.multiUpdatePlateList.splice(index, 1);
    this.multiUpdatePlateListSave.splice(index, 1);
    this.multiPlateStepsMapList.splice(index, 1);
    this.multiUpdatePlateInfoList.splice(index,1)
  }

  eligiblePlate(stage: number, stepName: string, actionName: string, actionPos: number) {
    if (stepName === 'ALIQUOTATION') {
      let isValidForAliquotation;
      if ((this.selectedPlate && this.selectedPlate.status === PlateStatus.EXTRACTION_COMPLETED) || (!this.selectedPlate || !this.selectedPlate.plateID)) {
        isValidForAliquotation = [PlateStatus.EXTRACTION_COMPLETED,PlateStatus.MERGE_COMPLETED].includes(this.fetchedPlate.status);
      } else {
        isValidForAliquotation = [PlateStatus.ALIQUOTATION_STARTED,PlateStatus.MERGE_COMPLETED].includes(this.fetchedPlate.status);
      }
      return !isValidForAliquotation;
    }
    if ((!this.multiPlateStepsMap || this.multiPlateStepsMap == null || this.multiPlateStepsMap.size < 1)) {
      return true;
    }
    switch (stage) {
      case ProcessStepStage.start:
        return this.disableProcessStepStart(stepName, this.multiPlateStepsMap);
      case ProcessStepStage.end:
        return this.disableProcessStepEnd(stepName, this.multiPlateStepsMap);
      case ProcessStepStage.action:
        return this.disableProcessStepAction(stepName, actionName, actionPos, this.multiPlateStepsMap);
      default:
        return true;
    }
  }

  removeMergeRedoPlatesFromLists(){
    this.multiUpdatePlateList = this.multiUpdatePlateList.filter(plateID => !plateID.endsWith("(MERGED_REDO)"));
    this.multiUpdatePlateListSave = this.multiUpdatePlateListSave.filter(plateID => !plateID.endsWith("(MERGED_REDO)"));
    this.multiUpdatePlateInfoList = this.multiUpdatePlateInfoList.filter(plateInfo => !plateInfo.lastUpdatedPlateID.endsWith("(MERGED_REDO)"));
    this.multiUpdateMergeRedoPlates.forEach( (plateUpdateInfoList) => {
      plateUpdateInfoList.forEach(plateUpdateInfo => {
        if(plateUpdateInfo.redo != RedoType.NO_REDO){
          this.multiUpdatePlateList.push(plateUpdateInfo.lastUpdatedPlateID);
          this.multiUpdatePlateListSave.push(plateUpdateInfo.lastUpdatedPlateID);
          this.multiUpdatePlateInfoList.push(plateUpdateInfo);
        }
      })
    })
  }

  getMultiUpdateDto() {
    let multiPlateUpdate: MultiPlateUpdate = new MultiPlateUpdate();
    multiPlateUpdate.action = this.multiActionName;
    multiPlateUpdate.plateids = this.multiUpdatePlateListSave;
    multiPlateUpdate.step = this.multiStepName;
    multiPlateUpdate.labid = this.selectedLabId;
    multiPlateUpdate.puid = this.puid;
    multiPlateUpdate.liquidHandler = this.multiLiquidHandler;
    multiPlateUpdate.status = this.multiUpdateStatus;
    if(this.multiCompleteProcessStep){
      multiPlateUpdate.completeProcessStep = this.multiCompleteProcessStep;
      multiPlateUpdate.status = this.multiCompleteProcessStepStatus;
    }
    if(this.multiChemicalLots.length !== 0){
      multiPlateUpdate.chemicals = [{
        "chemical": this.popUpWithMachineAndChemicalsChemical,
        "lots": this.multiChemicalLots
      }]
    }
    else{
      multiPlateUpdate.chemicals = []
    }
    multiPlateUpdate.actionRunTime = this.mapOfActionRuntimeAxiom384.get(this.multiActionName);
    multiPlateUpdate.machineUpdateInfoDict = this.multiMachineUpdateInfoDict
    multiPlateUpdate.plateUpdateInfoList = this.multiUpdatePlateInfoList;
    if(this.multiSealRequired){
      multiPlateUpdate.seal = this.multiSealLiquidHandler;
    }
    if(this.addFirstActionStatusList.includes(this.multiUpdateStatus)){
      multiPlateUpdate.addFirstAction = true;
    }
    return multiPlateUpdate;
  }

  updateStartProcessForMultiplePlates(goToNextStep: boolean = false) {
    let multiUpdateDto = this.getMultiUpdateDto();
    if(this.multiUpdateRestorePlateList.length > 0){
      this.restorePlatesFromStorage(this.multiUpdateRestorePlateList,() => {
        this.callBackUpdateStartProcessForMultiplePlates(multiUpdateDto,goToNextStep)
      })
      return
    }
    this.callBackUpdateStartProcessForMultiplePlates(multiUpdateDto,goToNextStep)
  }

  callBackUpdateStartProcessForMultiplePlates(multiUpdateDto,goToNextStep: boolean = false){
    this.blocked = true
    this.platePreparationService.updateStartProcessForMultiplePlates(multiUpdateDto).subscribe(
      (result) => {
        this.blocked = false;
        let nextStepParams = this.mapOfStatusAndPopUpValues.get(this.multiUpdateStatus)["nextStepParams"];
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result })
        this.lastUpdatedStatus = multiUpdateDto.status;
        this.updateLastUpdatedPlates();
        this.updateMultiPlateUpdateProcessStep(this.multiStepName, this.multiStage, this.multiActionName)
        if(this.multiUpdateStatus == PlateStatus.PRECIPITATION_STARTED){
          this.updateMultiPlateUpdateProcessStep(ProcessStep.PRECIPITATE_DNA, 2, Action.CENTRIFUGE)
        }
        if(this.multiUpdateStatus == PlateStatus.DENATURATION_STARTED){
          this.updateMultiPlateUpdateProcessStep(ProcessStep.DENATURATE_DNA, 2, Action.INCUBATE_95C)
        }

        this.closeMultiUpdatePopup();
        this.multiPlate = true;
        if ([PlateStatus.WGA_STARTED].includes(multiUpdateDto.status))
          this.updateMachine(multiUpdateDto.liquidHandler, multiUpdateDto.status, this.multiUpdateSelectedWorkFlow);
        if(goToNextStep){
          this.blocked = true
          setTimeout(() => {
            this.blocked = false
            this.savePlateStatus(nextStepParams[0], nextStepParams[1], nextStepParams[2], nextStepParams[3], nextStepParams[4])
          }, 1000);
        }
      },
      (error) => {
        this.blocked = false;
        if (this.multiStepName == ProcessStep.SAFE_STOPPING)
          this.multiUpdateStatus = PlateStatus.STORED;
       this.showError(error)
      }
    )
  }

  updateEndProcessForMultiplePlates(goToNextStep: boolean = false) {
    let multiUpdateDto = this.getMultiUpdateDto();
    if(this.multiUpdateRestorePlateList.length > 0){
      this.restorePlatesFromStorage(this.multiUpdateRestorePlateList,() => {
        this.callBackUpdateEndProcessForMultiplePlates(multiUpdateDto,goToNextStep)
      })
      return
    }
    this.callBackUpdateEndProcessForMultiplePlates(multiUpdateDto,goToNextStep)
  }

  callBackUpdateEndProcessForMultiplePlates(multiUpdateDto,goToNextStep:boolean = false){
    this.blocked = true
    this.platePreparationService.updateEndProcessForMultiplePlates(multiUpdateDto).subscribe(
      (result) => {
        this.blocked = false;
        let nextStepParams = this.mapOfStatusAndPopUpValues.get(this.multiUpdateStatus)["nextStepParams"];
        this.lastUpdatedStatus = multiUpdateDto.status;
        this.updateLastUpdatedPlates();
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result });

        this.updateMultiPlateUpdateProcessStep(this.multiStepName, this.multiStage, this.multiActionName)
        this.closeMultiUpdatePopup();
        this.multiPlate = true;
        if(goToNextStep){
          this.blocked = true
          setTimeout(() => {
            this.blocked = false
            this.savePlateStatus(nextStepParams[0], nextStepParams[1], nextStepParams[2], nextStepParams[3], nextStepParams[4])
          }, 1000);
        }
      },
      (error) => {
        this.blocked = false
        this.showError(error)
      }
    )
  }

  updateStartActionProcessForMultiplePlates(goToNextStep: boolean = false) {
    let multiUpdateDto = this.getMultiUpdateDto();
    if(this.multiUpdateRestorePlateList.length > 0){
      this.restorePlatesFromStorage(this.multiUpdateRestorePlateList, () => {
        this.callBackUpdateStartActionProcessForMultiplePlates(multiUpdateDto,goToNextStep)
      })
      return
    }
    this.callBackUpdateStartActionProcessForMultiplePlates(multiUpdateDto,goToNextStep)
  }

  callBackUpdateStartActionProcessForMultiplePlates(multiUpdateDto,goToNextStep:boolean = false){
    this.blocked = true
    this.platePreparationService.updateStartActionProcessForMultiplePlates(multiUpdateDto).subscribe(
      (result) => {
        this.blocked = false;
        let nextStepParams = this.mapOfStatusAndPopUpValues.get(this.multiUpdateStatus)["nextStepParams"];
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result })
        this.lastUpdatedStatus = multiUpdateDto.status;
        this.updateLastUpdatedPlates();

        this.updateMultiPlateUpdateProcessStep(this.multiStepName, this.multiStage, this.multiActionName)
        if(this.multiCompleteProcessStep){
          this.updateMultiPlateUpdateProcessStep(this.multiStepName, 1, this.multiActionName)
        }
        this.closeMultiUpdatePopup();
        this.multiPlate = true;
        if(goToNextStep){
          this.blocked = true
          setTimeout(() => {
            this.blocked = false
            this.savePlateStatus(nextStepParams[0], nextStepParams[1], nextStepParams[2], nextStepParams[3], nextStepParams[4])
          }, 1000);
        }
      },
      (error) => {
        this.blocked = false
        this.showError(error)
      }
    )
  }

  updateMultiPlates(goToNextStep:boolean = false) {
    if (!this.isPUIDPresent()) {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before moving ahead',
      });
      return;
    }
    switch (this.multiStage) {
      case ProcessStepStage.start:
        this.updateStartProcessForMultiplePlates(goToNextStep)
        break;
      case ProcessStepStage.end:
        this.updateEndProcessForMultiplePlates(goToNextStep);
        break;
      case ProcessStepStage.action:
        this.updateStartActionProcessForMultiplePlates(goToNextStep);
        break;
    }
  }

  resetLastUpdatedPlates() {
    this.lastUpdatedPlates1 = [];
    this.lastUpdatedPlates2 = [];
    this.lastUpdatedPlates3 = [];
    this.chemicalsPlateids = [];
  }

  updateLastUpdatedPlates() {
    this.resetLastUpdatedPlates();

    for (var i = 0; i < 30; i++) {
      let updatedPlate = { plateId: this.multiUpdatePlateList.length > i ? this.multiUpdatePlateList[i] : '' }
      if (i < 10) {
        this.lastUpdatedPlates1.push(updatedPlate)
      } else if (i < 20) {
        this.lastUpdatedPlates2.push(updatedPlate)
      } else {
        this.lastUpdatedPlates3.push(updatedPlate)
      }

      if (this.multiUpdatePlateList.length > i) {
        this.chemicalsPlateids.push(this.multiUpdatePlateListSave[i]);
      }
    }

  }

  closeMultiUpdatePopup(performFetchCalls: boolean = true) {
    this.showConfirmPlatesPopup = false;
    this.multiUpdatePlateList = [];
    this.enteredPlateId = "";
    this.enteredAliquotPlateId = "";
    this.multiUpdatePlateListSave = [];
    this.multiPlateStepsMap.clear();
    this.multiPlateStepsMapList = [];
    this.multiChemicalLots = []
    this.selectedPlateStepsMap.clear();
    this.multiCompleteProcessStep = undefined;
    this.multiCompleteProcessStepStatus = undefined;

    this.popUpWithMachineAndChemicals = false;
    this.popUpWithMachineAndChemicalsClosable = true;
    this.popUpWithDifferentMachine = false;
    this.popUpWithQCCheck = false;
    this.qcPass = false
    this.ismultiLiquidHandler = false
    this.ismultiSealLiquidHandler = false

    this.multiPlateIdRequired = [false,false];
    this.multiAliquotPlateIdRequired = [false,false];

    this.multiLiquidHandler = "";
    this.multiChemicalLot = "";
    this.multiPopupWithMachineAndChemicalsTableHeader = "";
    this.multiSpinRequired = false;
    this.multiPreSpinRequired = false;
    this.multiShakeRequired = false;
    this.multiAirDryRequired = false;
    this.multiLiquidHandlerRequired = true;

    this.multiUpdatePlateInfoList = [];
    this.multiMachineUpdateInfoDict = new Map();
    this.multiUpdateButtonStyleClass = "";
    this.multiUpdateStatusLabel = "";

    this.selectedRedoType = {"redoLabel":"No Redo","redo":RedoType.NO_REDO,"status":PlateStatus.PRECIPITATION_STARTED,"stepName":"","sampleType":""};
    this.disableRedoTypeSelection = true;
    if(performFetchCalls){
      this.reloadPlateTableEmitter.emit();
    }else if(this.selectedPlateProcessFlow.detailedWorkflow && this.selectedPlate.plateID !== undefined){
      this.searchForPlateAction(this.selectedPlate.plateID);
    }
    else{
      this.selectedPlate = null
    }
    this.underFilledPlate = new Set();
  }

  closePrecellPopup() {
    this.showPrecellPlatesPopup = false;
    this.precellPlateList = [];
    this.precellPlateData = [];
    this.multiPlateStepsMap = new Map();
    this.enteredPlateId = "";
    this.multiDenatChemicalLotList = []
    this.multiNeutChemicalLotList = []
    this.multiAmpChemicalLotList = []
    this.precellChemical1 = ''
    this.precellChemical2 = ''
    this.precellChemical3 = ''
  }

  checkMachineBarcode(liquidHandlerField: string, focusOnSource: boolean = false, focusOnAliquot: boolean = false, focusOnChemical:boolean = true){
    let machineBarcode = this[liquidHandlerField];
    if(machineBarcode.trim() == ""){
      return;
    }
    if(!this.machinesBarcodeMap.has(machineBarcode)){
      this._messagesService.addErrorMessage({
        severity:"error", summary:"Machine not found!",
        detail: "Machine with barcode "+machineBarcode+" not found. Please check the barcode and scan again."
      })
      this[`is${liquidHandlerField}`] = false
      this[liquidHandlerField] = "";
      return;
    }

    if(focusOnSource){
      this.findAndHighlightElement(this.selectedPopUpString+"-popup-plateid");
      return;
    }
    else if(focusOnAliquot){
      this.findAndHighlightElement(this.selectedPopUpString+"-popup-aliquot-plateid");
      return;
    }
    else if(focusOnChemical){
      this.findAndHighlightElement(this.selectedPopUpString+"-popup-chemical")
    }
    this[`is${liquidHandlerField}`] = true
    return;
  }

  checkChemicalLot(focusOnSealMachine: boolean = false){
    if(focusOnSealMachine){
      this.findAndHighlightElement(this.selectedPopUpString+"-popup-seal-machineid")
    }
    if(this.multiChemicalLot === ""){
      return;
    }
    this.multiChemicalLots.unshift(this.multiChemicalLot)
    this.multiChemicalLot = ""
  }

  deleteChemicalLot(index:number){
    this.multiChemicalLots.splice(index , 1);
  }

  checkNullAndUndefined(variable: any){
    return variable!=null && variable!=undefined
  }

  checkPlateForPrecell(){
    if(this.enteredPlateId && this.precellPlateList && this.precellPlateList.includes(this.enteredPlateId)) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Duplicate Plate', detail: 'Plate already Scanned.' });
      this.enteredPlateId = "";
      return;
    }
    if(this.enteredPlateId && this.precellPlateList && this.precellPlateList.length>20) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Max Plates Reached', detail: '20 Plates already Scanned.' });
      this.enteredPlateId = "";
      return;
    }
    if(this.enteredPlateId && this.enteredPlateId.trim()=="") {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Empty Plate', detail: 'Please scan a Plate.' });
      return;
    }
    this.blocked=true;
    this.platePreparationService.processDetailsbyPlateId(this.selectedLabId, this.enteredPlateId, PlateIdTypes.LAST_UPDATED_PLATEID).subscribe(
      (result)=>{
        this.blocked=false;
        let plateForPrecell = result;
        let workflowName = plateForPrecell.workFlow;
        this.prepareProcessStepMapforMultiPlateUpdate(plateForPrecell);
        let notEligible = this.eligiblePlate(0, ProcessStep.AMPLIFY_WGA, "", 0);
        let selectedWorkflow = this.getSelectedWorkFlow(workflowName);
        if(!selectedWorkflow){
          this._messagesService.addErrorMessage({severity: 'error', summary: 'No workflow found for plate'});
          this.plateViewResetEmitter.emit();
          return;
        }
        let processFlow: ProcessFlow;
        this.blocked=true;
        this.platePreparationService.getProcessFlow(plateForPrecell.processFlowName, this.selectedLabId).subscribe({
          next : (process_flow_result) => {
            this.blocked=false;
            if (process_flow_result.data) {
              processFlow = process_flow_result.data
              if(notEligible || !processFlow.axiom384Propel || !processFlow.precell){
                this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Plate Not eligible', detail: 'Please scan a diffrent Plate.' });
                this.enteredPlateId = "";
              } else{
                  this.precellPlateList.unshift(this.enteredPlateId);
                  let precellPlateInfo = new PrecellPlateInfo();
                  precellPlateInfo.plateID = this.enteredPlateId;
                  precellPlateInfo.processFlow = "Axiom_Propel_384";
                  this.precellPlateData.unshift(precellPlateInfo);
                  this.enteredPlateId ="";
              }
            } else {
              this._messagesService.addErrorMessage({
                severity: 'error', summary: 'No process flow found',
                detail: 'Either no configured process flow in MDM or no sample type in plate.'
              });
            }
          },
          error: (error: any) => {
            this.blocked = false;
            this.plateViewResetEmitter.emit();
            this.showError(error);
          }
        })
      },
      (_error)=>{
        this.blocked=false;
        this._messagesService.addErrorMessage({
          severity: "error", summary: "Plate not found!",
          detail: "Plate not found with plate id - " + this.enteredPlateId
        })
        this.enteredPlateId = "";
      }
    )
  }

  openPrecellPopUp(popUpType: string){
    if("workfile"==popUpType){
      this.precellPopupWorkfile = true;
    }
    else if("logfile"==popUpType){
      this.precellPopupWorkfile = false;
    }
    this.showPrecellPlatesPopup = true;
  }

  deletePrecellValue(index){
    this.precellPlateList.splice(index,1);
    this.precellPlateData.splice(index,1);
    this.findAndHighlightElement('precell-popup-plateid');
  }

  downloadPrecellFile() {
    this.blocked = true;
    this.platePreparationService.downloadPrecellWorkfile(this.selectedLabId, this.precellPlateData).subscribe({
        next: (precellWorkFile) => {
            this.blocked = false;
            this._messagesService.addSuccessMessage({
                severity: 'success', summary: 'Workfile Generated Successfully',
                detail: "Precell Workfile downloaded successfully"
            });
            saveByFileSaver(precellWorkFile.fileContent, precellWorkFile.filename);
            this.showPrecellPlatesPopup = false;
            this.closePrecellPopup();
        }, error: (_error) => {
            this.blocked = false;
            this._messagesService.addErrorMessage({
                severity: 'error', summary: 'Workfile not generated',
                detail: "Precell workfile generation failed"
            });
            this.showPrecellPlatesPopup = false;
            this.closePrecellPopup();
        }
    })
  }

  disablePrecellWorkfile(){
    if(!this.selectedPlateStepsMap.has(ProcessStep.ALIQUOTATION)){
      return true;
    }
    let currentProcessStep = this.selectedPlateStepsMap.get(ProcessStep.ALIQUOTATION);
    if(currentProcessStep.endTimeStamp || currentProcessStep.endPUID){
      return false
    }
    return true
  }

  getSelectedWorkFlow(workFlowName: string) : WorkFlow{
    let workflow = null;

    for(let wf of this.workFlowData) {
      if(wf.workFlowName == workFlowName) {
        workflow = wf;
        break;
      }
    }
    return workflow;
  }

  checkQCPlate(multiUpdatePlateType: string = PlateIdTypes.LAST_UPDATED_PLATEID, qcCheck: boolean = true, callback? : () => void) {

    let plateIDToBeChecked: string;
    if(PlateIdTypes.LAST_UPDATED_PLATEID == multiUpdatePlateType){
      plateIDToBeChecked = this.enteredPlateId.trim();
    }else if(PlateIdTypes.ALIQUOT == multiUpdatePlateType){
      plateIDToBeChecked = this.enteredAliquotPlateId.trim();
    }

    if (this.checkNullAndUndefined(plateIDToBeChecked) && this.checkNullAndUndefined(this.multiUpdatePlateList) && this.multiUpdatePlateList.includes(plateIDToBeChecked)) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Duplicate Plate', detail: 'Plate already Scanned.' });
      this.resetPlateIDs(multiUpdatePlateType);
      plateIDToBeChecked = undefined;
      return;
    }
    if (this.checkNullAndUndefined(plateIDToBeChecked) && this.checkNullAndUndefined(this.multiUpdatePlateList) && this.multiUpdatePlateList.length > 20) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Max Plates Reached', detail: '20 Plates already Scanned.' });
      this.resetPlateIDs(multiUpdatePlateType);
      plateIDToBeChecked = undefined;
      return;
    }
    if (this.checkNullAndUndefined(plateIDToBeChecked) && plateIDToBeChecked.trim() == "") {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Empty Plate', detail: 'Please scan a Plate.' });
      this.resetPlateIDs(multiUpdatePlateType);
      plateIDToBeChecked = undefined;
      return;
    }
    this.blocked = true;
    this.platePreparationService.processDetailsbyPlateId(this.selectedLabId, plateIDToBeChecked, multiUpdatePlateType).subscribe(
      (result) => {
        this.blocked = false;
        this.fetchedPlate = result;
        this.prepareProcessStepMapforMultiPlateUpdate(this.fetchedPlate);
        let notEligible = this.eligiblePlate(this.multiStage, this.multiStepName, this.multiActionName, this.multiActionPos);
        if (notEligible) {
          this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Plate Not eligible', detail: 'Please scan a diffrent Plate.' });
          this.resetPlateIDs(multiUpdatePlateType);
          plateIDToBeChecked = "";
        } else if(!this.qcPass && this.fetchedPlate.sourcePlates?.length!=0){
          this.showRedoPopUpForMergePlate(this.fetchedPlate)
        }else{
          this.populateRedoTypeDropdown(this.fetchedPlate, qcCheck,callback);
          this.qcFailPlateSampleMap.set(this.fetchedPlate.lastUpdatedPlateID, this.fetchedPlate.samples)
        }
      },
      (_error) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: "error", summary: "Plate not found!",
          detail: "Plate not found with plate id - " + plateIDToBeChecked
        })
        this.resetPlateIDs(multiUpdatePlateType);
        plateIDToBeChecked = "";
      }
    )
  }

  populateRedoTypeDropdown(plate: Plate, qcCheck: boolean,callback : () => void){
    let selectedWorkflow = this.getSelectedWorkFlow(plate.workFlow);
    if(!selectedWorkflow){
      this._messagesService.addErrorMessage({severity: 'error', summary: 'No workflow found for plate'});
      this.resetPlateIDs(PlateIdTypes.LAST_UPDATED_PLATEID);
      return;
    }
    let processFlow: ProcessFlow;
    this.blocked=true;
    this.platePreparationService.getProcessFlow(plate.processFlowName, this.selectedLabId).subscribe({
      next : (process_flow_result) => {
        this.blocked=false;
        if (process_flow_result.data) {
          processFlow = process_flow_result.data

          this.updateRedoList(processFlow.okTOpureHair, processFlow.okTOpureEartag, processFlow.ExEartagTLR)

          if(plate.sampleType=="DNA" && plate.processSteps.length > 1){
            if(plate.workFlow=="ICBF"){
              this.redoList.push({label: "DNA Redo", value: {"redo": RedoType.DNA_REDO, "redoLabel": "DNA Redo", "sampleType": "DNA", "stepName": plate.processSteps[1].step, status: PlateStatus.RECEPTION_COMPLETED}});
            }else{
              this.redoList.push({label: "DNA Redo", value: {"redo": RedoType.DNA_REDO, "redoLabel": "DNA Redo", "sampleType": "DNA", "stepName": plate.processSteps[1].step, status: PlateStatus.RECEIVED}});
            }
          }
          this.selectedRedoType = this.redoList[0]

          if(!qcCheck){
            this.disableRedoTypeSelection = false;
            this.popUpRedoSelector.focus();
            this.popUpRedoSelector.show();
          }
          callback()
        }
        else {
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'No process flow found',
            detail: 'Either no configured process flow in MDM or no sample type in plate.'
          });
        }
      },
      error: (error: any) => {
        this.blocked = false;
        this.plateViewResetEmitter.emit();
        this.showError(error);
      }
    })
  }

  updateRedoList(okTOpureHair: boolean, okTOpureEartag: boolean, ExEartagTLR: boolean) {
    if(okTOpureHair){
      this.redoList = this.hairRedoList;
    }else if(okTOpureEartag){
      this.redoList = this.eartagRedoList;
    }else if(ExEartagTLR){
      this.redoList = this.tlrRedoList;
    }else{
      this.redoList = [];
    }
  }

  qcCheck(){
    this.checkQCPlate('LUP', true, () => {
      this.selectedRedoType = this.qcPassSelectedRedoType
      this.addPlateForQCCheck(true)
    })
  }

  addPlateForQCCheck(qcPass: boolean){
    if(this.selectedRedoType.redoLabel.length==0){
      this.popUpRedoSelector.focus();
      this.popUpRedoSelector.show();
      return;
    }
    if(this.enteredPlateId === ''){
      this.highlightElementDuringQC(qcPass)
      return
    }
    let plateUpdateInfo = new PlateUpdateInfo();
    plateUpdateInfo.plateID = this.fetchedPlate.plateID;
    plateUpdateInfo.lastUpdatedPlateID = this.enteredPlateId;
    plateUpdateInfo.redoLabel = this.selectedRedoType.redoLabel;
    plateUpdateInfo.redo = this.selectedRedoType.redo;
    plateUpdateInfo.status = this.selectedRedoType.status;
    plateUpdateInfo.sampleType = this.selectedRedoType.sampleType;
    plateUpdateInfo.stepName = this.selectedRedoType.stepName;;
    if (!this.multiUpdatePlateInfoList.some(item => item.plateID === plateUpdateInfo.plateID)) {
      this.multiUpdatePlateInfoList.unshift(plateUpdateInfo);
   }
    this.multiUpdatePlateList.unshift(this.enteredPlateId);
    this.multiUpdatePlateListSave.unshift(this.enteredPlateId);
    this.enteredPlateId = "";
    this.selectedRedoType = {"redoLabel":"No Redo","redo":RedoType.NO_REDO,"status":PlateStatus.PRECIPITATION_STARTED,"stepName":"","sampleType":""};
    this.redoList = [];
    this.disableRedoTypeSelection = true;
    this.highlightElementDuringQC(qcPass)
  }

  highlightElementDuringQC(qcPass:boolean){
    if(qcPass){
      this.findAndHighlightElement("qcpass-plate-id")
    }
    else{
      this.findAndHighlightElement("popUpWithQCCheck-popup-plateid")
    }
  }

  updateMultiQCCheckPlates(goToNextStep: boolean = false) {
    this.removeMergeRedoPlatesFromLists();
    let multiUpdateDto = this.getMultiUpdateDto();

    if(multiUpdateDto.plateUpdateInfoList.length == 0 && this.multiUpdateMergeRedoPlates.size!=0){
      this.updateMultiMergeQCCheckPlates(goToNextStep);
      return;
    }

    const sampleUpdateDetails = new SampleRedoDTO();
    sampleUpdateDetails.sampleIdList = multiUpdateDto.plateids
      .map((plateId) => this.qcFailPlateSampleMap.get(plateId))
      .map((samples) =>
        samples.map((sample) => ({
          sampleID: sample._id,
          type: AnalysisType.INTERNAL_RERUN,
        }))
      )
      .reduce((samples, currentSamples) => samples.concat(currentSamples), []);

    sampleUpdateDetails.analysisType = true;
    sampleUpdateDetails.reRunCount = false;

    this.blocked = true
    this.platePreparationService.updateQCCheckForMultiplePlates(multiUpdateDto, this.selectedLabId).subscribe(
      (result) => {
        this.announcementService.updateRedoSample(this.selectedLabId,  sampleUpdateDetails).subscribe(
          _result=>{
            this._messagesService.addSuccessMessage({
              severity:'success',summary:"Success!", detail: result
            })
          }
        )
        this.blocked = false;
        if(this.multiUpdateMergeRedoPlates.size!=0){
          this.updateMultiMergeQCCheckPlates(goToNextStep);
        }else{
          let nextStepParams = this.mapOfStatusAndPopUpValues.get(this.multiUpdateStatus)["nextStepParams"];
          this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result })
          this.lastUpdatedStatus = multiUpdateDto.status;
          this.updateLastUpdatedPlates();
          this.updateMultiPlateUpdateProcessStep(this.multiStepName, this.multiStage, this.multiActionName)
          this.closeMultiUpdatePopup();
          this.multiPlate = true;
          if(goToNextStep){
            this.blocked = true
            setTimeout(() => {
              this.blocked = false
              this.savePlateStatus(nextStepParams[0], nextStepParams[1], nextStepParams[2], nextStepParams[3], nextStepParams[4])
            }, 1000);
          }
        }
      },
      (error) => {
        this.blocked = false
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    )
  }

  prepareMergePlateQCScanDTO(){
    let dto: MultiMergePlateQCUpdate = new MultiMergePlateQCUpdate();
    dto.labid = this.selectedLabId;
    dto.action = this.multiActionName;
    dto.step = this.multiStepName;
    dto.labid = this.selectedLabId;
    dto.puid = this.puid;
    dto.status = this.multiUpdateStatus;
    this.multiUpdateMergeRedoPlates.forEach( (value, key) => {
      dto.plateids.push(key);
      dto.plateUpdateInfoList[key] = value
    })
    return dto
  }

  updateMultiMergeQCCheckPlates(goToNextStep: boolean = false){
    let multiUpdateDTO = this.prepareMergePlateQCScanDTO();
    this.blocked = true
    this.platePreparationService.updateQCCheckForMultipleMergePlates(multiUpdateDTO, this.selectedLabId).subscribe(
      (result) => {
        this.blocked = false;
        this.multiUpdateMergeRedoPlates.clear();
        let nextStepParams = this.mapOfStatusAndPopUpValues.get(this.multiUpdateStatus)["nextStepParams"];
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result })
        this.lastUpdatedStatus = multiUpdateDTO.status;
        this.updateLastUpdatedPlates();
        this.updateMultiPlateUpdateProcessStep(this.multiStepName, this.multiStage, this.multiActionName)
        this.closeMultiUpdatePopup();
        this.multiPlate = true;
        if(goToNextStep){
          this.blocked = true
          setTimeout(() => {
            this.blocked = false
            this.savePlateStatus(nextStepParams[0], nextStepParams[1], nextStepParams[2], nextStepParams[3], nextStepParams[4])
          }, 1000);
        }
      },
      (error) => {
        this.blocked = false
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    )
  }

  isMultiPlateOrDetailedWorkflow(){
    return (this.multiPlate || this.selectedPlateProcessFlow.detailedWorkflow)
  }

  openQCPassPopUp(){
    this.qcPass = true
    this.multiUpdatePlateInfoList = []
    this.multiStage = 2
    this.multiStepName = ProcessStep.PRECIPITATE_DNA
    this.multiActionName = Action.QC_CHECK
    this.multiActionPos = 2
    this.multiUpdateStatus = Action.QC_CHECK
  }

  disableShakeCheckbox(){
    return this.multiShakeCheckboxValue || !this.multiPreSpinCheckboxValue || (this.multiSealRequired && !this.ismultiSealLiquidHandler) || (this.multiLiquidHandlerRequired && ((this.multiLiquidHandler == '') || (this.multiChemicalLots.length === 0)))
  }

  disableSealLiquidHandler(){
    return this.multiLiquidHandlerRequired && ((this.multiLiquidHandler == '') || (this.multiChemicalLots.length === 0))
  }

  checkDisableButtonForPopupWithDifferentMachineAndChemicals(): boolean{
    if(this.multiUpdateStatus === ""){
      return false;
    }
    let isDisabled = true
    let currentAction = this.multiUpdateStatus
    let processAction = this.mapOfStatusAndPopUpValues.get(currentAction)
    if(!processAction){
      return false
    }
    if(processAction.preSpin){
      isDisabled = isDisabled && this.multiPreSpinCheckboxValue
    }

    if(processAction.spin){
      isDisabled = isDisabled && this.multiSpinCheckboxValue
    }

    if(processAction.shake){
      isDisabled = isDisabled && this.multiShakeCheckboxValue
    }

    if(processAction.seal){
      isDisabled = isDisabled && this.multiSealLiquidHandler !== "" && this.ismultiSealLiquidHandler
    }

    return !isDisabled
  }

  showRedoPopUpForMergePlate(fetchedPlate: Plate){
    this.popUpWithQCCheckForMergePlate = true;
    this.mergePlateRedoSelection = [];
    fetchedPlate.sourcePlates.forEach( (sourcePlate,index) => {
      this.mergePlateRedoSelection.push({});
      this.mergePlateRedoList.push([]);
      this.getMergePlateRedoList(sourcePlate.processFlowName, index);
    })
  }

  getMergePlateRedoList(processFlowName: string, index: number): Array<any>{
    let selectedWorkflow = this.getSelectedWorkFlow(this.fetchedPlate.workFlow);
    if(!selectedWorkflow){
      this._messagesService.addErrorMessage({severity: 'error', summary: 'No workflow found for plate'});
      this.popUpWithQCCheckForMergePlate = false;
      return;
    }
    let processFlow: ProcessFlow;
    let redoList = [];
    this.blocked=true;
    this.platePreparationService.getProcessFlow(processFlowName, this.selectedLabId).subscribe({
      next : (process_flow_result) => {
        this.blocked=false;
        if (process_flow_result.data) {
          processFlow = process_flow_result.data

          redoList = this.setRedoList(processFlow);

          if(this.fetchedPlate.sampleType=="DNA" && this.fetchedPlate.processSteps.length > 1){
            redoList.push({label: "DNA Redo", value: {"redo": RedoType.DNA_REDO, "redoLabel": "DNA Redo", "sampleType": "DNA", "stepName": this.fetchedPlate.processSteps[1].step, status: PlateStatus.RECEIVED}});
          }

          redoList.unshift({label: "No Redo", value: {"redoLabel":"No Redo","redo":RedoType.NO_REDO,"status":PlateStatus.PRECIPITATION_STARTED,"stepName":"","sampleType":""}})
          this.mergePlateRedoList[index]=redoList;
        }
        else {
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'No process flow found',
            detail: 'Either no configured process flow in MDM or no sample type in plate.'
          });
        }
      },
      error: (error: any) => {
        this.blocked = false;
        this.popUpWithQCCheckForMergePlate = false;
        this.showError(error);
      }
    })
  }

  setRedoList(processFlow: ProcessFlow) {
      if (processFlow.okTOpureHair) {
        return this.clone(this.hairRedoList);
      } else if (processFlow.okTOpureEartag) {
        return this.clone(this.eartagRedoList);
      } else if (processFlow.ExEartagTLR) {
        return this.clone(this.tlrRedoList);
      } else {
        return [];
      }
  }

  updateMultiQCCheckForMergedPlates(){
    let mergePlateUpdateInfoList = [];

    let plateUpdateInfo = new PlateUpdateInfo();
    plateUpdateInfo.plateID = this.fetchedPlate.plateID + `(${this.fetchedPlate.sourcePlates.map(plate => plate.plateID).join("/")})`;
    plateUpdateInfo.lastUpdatedPlateID = this.enteredPlateId + '(MERGED_REDO)';
    plateUpdateInfo.redoLabel = "";
    plateUpdateInfo.redo = "";
    plateUpdateInfo.status = "";
    plateUpdateInfo.sampleType = "";
    plateUpdateInfo.stepName = "";

    this.mergePlateRedoSelection.forEach((redoSelection, index) => {
      let mergePlateUpdateInfo = new PlateUpdateInfo();
      mergePlateUpdateInfo.plateID = this.fetchedPlate.sourcePlates[index].plateID;
      mergePlateUpdateInfo.lastUpdatedPlateID = this.fetchedPlate.sourcePlates[index].lastUpdatedPlateID;
      mergePlateUpdateInfo.redoLabel = redoSelection.redoLabel;
      mergePlateUpdateInfo.redo = redoSelection.redo;
      mergePlateUpdateInfo.status = redoSelection.status;
      mergePlateUpdateInfo.sampleType = redoSelection.sampleType;
      mergePlateUpdateInfo.stepName = redoSelection.stepName;

      plateUpdateInfo.redoLabel += redoSelection.redoLabel + ", ";
      plateUpdateInfo.redo += redoSelection.redo + ", ";
      plateUpdateInfo.status += redoSelection.status + ", ";
      plateUpdateInfo.sampleType += redoSelection.sampleType + ", ";
      plateUpdateInfo.stepName += redoSelection.stepName + ", ";

      mergePlateUpdateInfoList.push(mergePlateUpdateInfo);
      if(RedoType.NO_REDO != redoSelection.redo){
        this.qcFailPlateSampleMap.set(this.fetchedPlate.sourcePlates[index].lastUpdatedPlateID, this.fetchedPlate.samples.filter(sample => sample.sourcePlateID == this.fetchedPlate.sourcePlates[index].lastUpdatedPlateID))
      }
    });

    this.multiUpdateMergeRedoPlates.set(this.fetchedPlate.lastUpdatedPlateID, mergePlateUpdateInfoList);

    if (!this.multiUpdatePlateInfoList.some(item => item.plateID === plateUpdateInfo.plateID)) {
      this.multiUpdatePlateInfoList.unshift(plateUpdateInfo);
    }
    this.multiUpdatePlateList.unshift(this.enteredPlateId + '(MERGED_REDO)');
    this.multiUpdatePlateListSave.unshift(this.enteredPlateId + '(MERGED_REDO)');
    this.enteredPlateId = "";
    this.selectedRedoType = { "redoLabel": "No Redo", "redo": RedoType.NO_REDO, "status": PlateStatus.PRECIPITATION_STARTED, "stepName": "", "sampleType": "" };
    this.redoList = [];
    this.mergePlateRedoList = [];
    this.mergePlateRedoSelection = []
    this.disableRedoTypeSelection = true;
    this.popUpWithQCCheckForMergePlate = false;
    this.findAndHighlightElement("popUpWithQCCheck-popup-plateid")
  }

  disableUpdateMultiQCCheckForMergedPlatesButton(): boolean{
    let disable = false;

    this.mergePlateRedoSelection.forEach(redoSelection => {
      if(Object.keys(redoSelection).length == 0){
        disable = true;
      }
    })

    return disable;
  }

}
